"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TwoFA", {
  enumerable: true,
  get: function get() {
    return _fa["default"];
  }
});
Object.defineProperty(exports, "ThreeDCubeSphere", {
  enumerable: true,
  get: function get() {
    return _dCubeSphere["default"];
  }
});
Object.defineProperty(exports, "AB", {
  enumerable: true,
  get: function get() {
    return _aB["default"];
  }
});
Object.defineProperty(exports, "AccessPointOff", {
  enumerable: true,
  get: function get() {
    return _accessPointOff["default"];
  }
});
Object.defineProperty(exports, "AccessPoint", {
  enumerable: true,
  get: function get() {
    return _accessPoint["default"];
  }
});
Object.defineProperty(exports, "Accessible", {
  enumerable: true,
  get: function get() {
    return _accessible["default"];
  }
});
Object.defineProperty(exports, "Activity", {
  enumerable: true,
  get: function get() {
    return _activity["default"];
  }
});
Object.defineProperty(exports, "Ad", {
  enumerable: true,
  get: function get() {
    return _ad["default"];
  }
});
Object.defineProperty(exports, "AdjustmentsAlt", {
  enumerable: true,
  get: function get() {
    return _adjustmentsAlt["default"];
  }
});
Object.defineProperty(exports, "AdjustmentsHorizontal", {
  enumerable: true,
  get: function get() {
    return _adjustmentsHorizontal["default"];
  }
});
Object.defineProperty(exports, "Adjustments", {
  enumerable: true,
  get: function get() {
    return _adjustments["default"];
  }
});
Object.defineProperty(exports, "Alarm", {
  enumerable: true,
  get: function get() {
    return _alarm["default"];
  }
});
Object.defineProperty(exports, "AlertCircle", {
  enumerable: true,
  get: function get() {
    return _alertCircle["default"];
  }
});
Object.defineProperty(exports, "AlertOctagon", {
  enumerable: true,
  get: function get() {
    return _alertOctagon["default"];
  }
});
Object.defineProperty(exports, "AlertTriangle", {
  enumerable: true,
  get: function get() {
    return _alertTriangle["default"];
  }
});
Object.defineProperty(exports, "Alien", {
  enumerable: true,
  get: function get() {
    return _alien["default"];
  }
});
Object.defineProperty(exports, "AlignCenter", {
  enumerable: true,
  get: function get() {
    return _alignCenter["default"];
  }
});
Object.defineProperty(exports, "AlignJustified", {
  enumerable: true,
  get: function get() {
    return _alignJustified["default"];
  }
});
Object.defineProperty(exports, "AlignLeft", {
  enumerable: true,
  get: function get() {
    return _alignLeft["default"];
  }
});
Object.defineProperty(exports, "AlignRight", {
  enumerable: true,
  get: function get() {
    return _alignRight["default"];
  }
});
Object.defineProperty(exports, "Ambulance", {
  enumerable: true,
  get: function get() {
    return _ambulance["default"];
  }
});
Object.defineProperty(exports, "Anchor", {
  enumerable: true,
  get: function get() {
    return _anchor["default"];
  }
});
Object.defineProperty(exports, "AntennaBars1", {
  enumerable: true,
  get: function get() {
    return _antennaBars["default"];
  }
});
Object.defineProperty(exports, "AntennaBars2", {
  enumerable: true,
  get: function get() {
    return _antennaBars2["default"];
  }
});
Object.defineProperty(exports, "AntennaBars3", {
  enumerable: true,
  get: function get() {
    return _antennaBars3["default"];
  }
});
Object.defineProperty(exports, "AntennaBars4", {
  enumerable: true,
  get: function get() {
    return _antennaBars4["default"];
  }
});
Object.defineProperty(exports, "AntennaBars5", {
  enumerable: true,
  get: function get() {
    return _antennaBars5["default"];
  }
});
Object.defineProperty(exports, "Aperture", {
  enumerable: true,
  get: function get() {
    return _aperture["default"];
  }
});
Object.defineProperty(exports, "Apps", {
  enumerable: true,
  get: function get() {
    return _apps["default"];
  }
});
Object.defineProperty(exports, "Archive", {
  enumerable: true,
  get: function get() {
    return _archive["default"];
  }
});
Object.defineProperty(exports, "ArrowBackUp", {
  enumerable: true,
  get: function get() {
    return _arrowBackUp["default"];
  }
});
Object.defineProperty(exports, "ArrowBack", {
  enumerable: true,
  get: function get() {
    return _arrowBack["default"];
  }
});
Object.defineProperty(exports, "ArrowBarDown", {
  enumerable: true,
  get: function get() {
    return _arrowBarDown["default"];
  }
});
Object.defineProperty(exports, "ArrowBarLeft", {
  enumerable: true,
  get: function get() {
    return _arrowBarLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowBarRight", {
  enumerable: true,
  get: function get() {
    return _arrowBarRight["default"];
  }
});
Object.defineProperty(exports, "ArrowBarToDown", {
  enumerable: true,
  get: function get() {
    return _arrowBarToDown["default"];
  }
});
Object.defineProperty(exports, "ArrowBarToLeft", {
  enumerable: true,
  get: function get() {
    return _arrowBarToLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowBarToRight", {
  enumerable: true,
  get: function get() {
    return _arrowBarToRight["default"];
  }
});
Object.defineProperty(exports, "ArrowBarToUp", {
  enumerable: true,
  get: function get() {
    return _arrowBarToUp["default"];
  }
});
Object.defineProperty(exports, "ArrowBarUp", {
  enumerable: true,
  get: function get() {
    return _arrowBarUp["default"];
  }
});
Object.defineProperty(exports, "ArrowDownCircle", {
  enumerable: true,
  get: function get() {
    return _arrowDownCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowDownLeftCircle", {
  enumerable: true,
  get: function get() {
    return _arrowDownLeftCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowDownLeft", {
  enumerable: true,
  get: function get() {
    return _arrowDownLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowDownRightCircle", {
  enumerable: true,
  get: function get() {
    return _arrowDownRightCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowDownRight", {
  enumerable: true,
  get: function get() {
    return _arrowDownRight["default"];
  }
});
Object.defineProperty(exports, "ArrowDown", {
  enumerable: true,
  get: function get() {
    return _arrowDown["default"];
  }
});
Object.defineProperty(exports, "ArrowForwardUp", {
  enumerable: true,
  get: function get() {
    return _arrowForwardUp["default"];
  }
});
Object.defineProperty(exports, "ArrowForward", {
  enumerable: true,
  get: function get() {
    return _arrowForward["default"];
  }
});
Object.defineProperty(exports, "ArrowLeftCircle", {
  enumerable: true,
  get: function get() {
    return _arrowLeftCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowLeft", {
  enumerable: true,
  get: function get() {
    return _arrowLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowNarrowDown", {
  enumerable: true,
  get: function get() {
    return _arrowNarrowDown["default"];
  }
});
Object.defineProperty(exports, "ArrowNarrowLeft", {
  enumerable: true,
  get: function get() {
    return _arrowNarrowLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowNarrowRight", {
  enumerable: true,
  get: function get() {
    return _arrowNarrowRight["default"];
  }
});
Object.defineProperty(exports, "ArrowNarrowUp", {
  enumerable: true,
  get: function get() {
    return _arrowNarrowUp["default"];
  }
});
Object.defineProperty(exports, "ArrowRampLeft", {
  enumerable: true,
  get: function get() {
    return _arrowRampLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowRampRight", {
  enumerable: true,
  get: function get() {
    return _arrowRampRight["default"];
  }
});
Object.defineProperty(exports, "ArrowRightCircle", {
  enumerable: true,
  get: function get() {
    return _arrowRightCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowRight", {
  enumerable: true,
  get: function get() {
    return _arrowRight["default"];
  }
});
Object.defineProperty(exports, "ArrowUpCircle", {
  enumerable: true,
  get: function get() {
    return _arrowUpCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowUpLeftCircle", {
  enumerable: true,
  get: function get() {
    return _arrowUpLeftCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowUpLeft", {
  enumerable: true,
  get: function get() {
    return _arrowUpLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowUpRightCircle", {
  enumerable: true,
  get: function get() {
    return _arrowUpRightCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowUpRight", {
  enumerable: true,
  get: function get() {
    return _arrowUpRight["default"];
  }
});
Object.defineProperty(exports, "ArrowUp", {
  enumerable: true,
  get: function get() {
    return _arrowUp["default"];
  }
});
Object.defineProperty(exports, "ArrowsDiagonal2", {
  enumerable: true,
  get: function get() {
    return _arrowsDiagonal["default"];
  }
});
Object.defineProperty(exports, "ArrowsDiagonal", {
  enumerable: true,
  get: function get() {
    return _arrowsDiagonal2["default"];
  }
});
Object.defineProperty(exports, "ArrowsHorizontal", {
  enumerable: true,
  get: function get() {
    return _arrowsHorizontal["default"];
  }
});
Object.defineProperty(exports, "ArrowsMaximize", {
  enumerable: true,
  get: function get() {
    return _arrowsMaximize["default"];
  }
});
Object.defineProperty(exports, "ArrowsMinimize", {
  enumerable: true,
  get: function get() {
    return _arrowsMinimize["default"];
  }
});
Object.defineProperty(exports, "ArrowsSort", {
  enumerable: true,
  get: function get() {
    return _arrowsSort["default"];
  }
});
Object.defineProperty(exports, "ArrowsVertical", {
  enumerable: true,
  get: function get() {
    return _arrowsVertical["default"];
  }
});
Object.defineProperty(exports, "Artboard", {
  enumerable: true,
  get: function get() {
    return _artboard["default"];
  }
});
Object.defineProperty(exports, "AspectRatio", {
  enumerable: true,
  get: function get() {
    return _aspectRatio["default"];
  }
});
Object.defineProperty(exports, "At", {
  enumerable: true,
  get: function get() {
    return _at["default"];
  }
});
Object.defineProperty(exports, "Atom2", {
  enumerable: true,
  get: function get() {
    return _atom["default"];
  }
});
Object.defineProperty(exports, "Atom", {
  enumerable: true,
  get: function get() {
    return _atom2["default"];
  }
});
Object.defineProperty(exports, "Award", {
  enumerable: true,
  get: function get() {
    return _award["default"];
  }
});
Object.defineProperty(exports, "Backhoe", {
  enumerable: true,
  get: function get() {
    return _backhoe["default"];
  }
});
Object.defineProperty(exports, "Backspace", {
  enumerable: true,
  get: function get() {
    return _backspace["default"];
  }
});
Object.defineProperty(exports, "BallBasketball", {
  enumerable: true,
  get: function get() {
    return _ballBasketball["default"];
  }
});
Object.defineProperty(exports, "BallBowling", {
  enumerable: true,
  get: function get() {
    return _ballBowling["default"];
  }
});
Object.defineProperty(exports, "BallTennis", {
  enumerable: true,
  get: function get() {
    return _ballTennis["default"];
  }
});
Object.defineProperty(exports, "BallVolleyball", {
  enumerable: true,
  get: function get() {
    return _ballVolleyball["default"];
  }
});
Object.defineProperty(exports, "Ban", {
  enumerable: true,
  get: function get() {
    return _ban["default"];
  }
});
Object.defineProperty(exports, "Bandage", {
  enumerable: true,
  get: function get() {
    return _bandage["default"];
  }
});
Object.defineProperty(exports, "Barcode", {
  enumerable: true,
  get: function get() {
    return _barcode["default"];
  }
});
Object.defineProperty(exports, "Basket", {
  enumerable: true,
  get: function get() {
    return _basket["default"];
  }
});
Object.defineProperty(exports, "Battery1", {
  enumerable: true,
  get: function get() {
    return _battery["default"];
  }
});
Object.defineProperty(exports, "Battery2", {
  enumerable: true,
  get: function get() {
    return _battery2["default"];
  }
});
Object.defineProperty(exports, "Battery3", {
  enumerable: true,
  get: function get() {
    return _battery3["default"];
  }
});
Object.defineProperty(exports, "Battery4", {
  enumerable: true,
  get: function get() {
    return _battery4["default"];
  }
});
Object.defineProperty(exports, "BatteryCharging", {
  enumerable: true,
  get: function get() {
    return _batteryCharging["default"];
  }
});
Object.defineProperty(exports, "BatteryOff", {
  enumerable: true,
  get: function get() {
    return _batteryOff["default"];
  }
});
Object.defineProperty(exports, "Battery", {
  enumerable: true,
  get: function get() {
    return _battery5["default"];
  }
});
Object.defineProperty(exports, "Bed", {
  enumerable: true,
  get: function get() {
    return _bed["default"];
  }
});
Object.defineProperty(exports, "BellOff", {
  enumerable: true,
  get: function get() {
    return _bellOff["default"];
  }
});
Object.defineProperty(exports, "BellRinging", {
  enumerable: true,
  get: function get() {
    return _bellRinging["default"];
  }
});
Object.defineProperty(exports, "Bell", {
  enumerable: true,
  get: function get() {
    return _bell["default"];
  }
});
Object.defineProperty(exports, "Bike", {
  enumerable: true,
  get: function get() {
    return _bike["default"];
  }
});
Object.defineProperty(exports, "Biohazard", {
  enumerable: true,
  get: function get() {
    return _biohazard["default"];
  }
});
Object.defineProperty(exports, "BluetoothConnected", {
  enumerable: true,
  get: function get() {
    return _bluetoothConnected["default"];
  }
});
Object.defineProperty(exports, "BluetoothOff", {
  enumerable: true,
  get: function get() {
    return _bluetoothOff["default"];
  }
});
Object.defineProperty(exports, "Bluetooth", {
  enumerable: true,
  get: function get() {
    return _bluetooth["default"];
  }
});
Object.defineProperty(exports, "Bold", {
  enumerable: true,
  get: function get() {
    return _bold["default"];
  }
});
Object.defineProperty(exports, "BoltOff", {
  enumerable: true,
  get: function get() {
    return _boltOff["default"];
  }
});
Object.defineProperty(exports, "Bolt", {
  enumerable: true,
  get: function get() {
    return _bolt["default"];
  }
});
Object.defineProperty(exports, "Book", {
  enumerable: true,
  get: function get() {
    return _book["default"];
  }
});
Object.defineProperty(exports, "BookmarkOff", {
  enumerable: true,
  get: function get() {
    return _bookmarkOff["default"];
  }
});
Object.defineProperty(exports, "Bookmark", {
  enumerable: true,
  get: function get() {
    return _bookmark["default"];
  }
});
Object.defineProperty(exports, "Bookmarks", {
  enumerable: true,
  get: function get() {
    return _bookmarks["default"];
  }
});
Object.defineProperty(exports, "BorderAll", {
  enumerable: true,
  get: function get() {
    return _borderAll["default"];
  }
});
Object.defineProperty(exports, "BorderBottom", {
  enumerable: true,
  get: function get() {
    return _borderBottom["default"];
  }
});
Object.defineProperty(exports, "BorderHorizontal", {
  enumerable: true,
  get: function get() {
    return _borderHorizontal["default"];
  }
});
Object.defineProperty(exports, "BorderInner", {
  enumerable: true,
  get: function get() {
    return _borderInner["default"];
  }
});
Object.defineProperty(exports, "BorderLeft", {
  enumerable: true,
  get: function get() {
    return _borderLeft["default"];
  }
});
Object.defineProperty(exports, "BorderNone", {
  enumerable: true,
  get: function get() {
    return _borderNone["default"];
  }
});
Object.defineProperty(exports, "BorderOuter", {
  enumerable: true,
  get: function get() {
    return _borderOuter["default"];
  }
});
Object.defineProperty(exports, "BorderRadius", {
  enumerable: true,
  get: function get() {
    return _borderRadius["default"];
  }
});
Object.defineProperty(exports, "BorderRight", {
  enumerable: true,
  get: function get() {
    return _borderRight["default"];
  }
});
Object.defineProperty(exports, "BorderTop", {
  enumerable: true,
  get: function get() {
    return _borderTop["default"];
  }
});
Object.defineProperty(exports, "BorderVertical", {
  enumerable: true,
  get: function get() {
    return _borderVertical["default"];
  }
});
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function get() {
    return _box["default"];
  }
});
Object.defineProperty(exports, "Braces", {
  enumerable: true,
  get: function get() {
    return _braces["default"];
  }
});
Object.defineProperty(exports, "Brackets", {
  enumerable: true,
  get: function get() {
    return _brackets["default"];
  }
});
Object.defineProperty(exports, "BrandAirbnb", {
  enumerable: true,
  get: function get() {
    return _brandAirbnb["default"];
  }
});
Object.defineProperty(exports, "BrandAndroid", {
  enumerable: true,
  get: function get() {
    return _brandAndroid["default"];
  }
});
Object.defineProperty(exports, "BrandAppleArcade", {
  enumerable: true,
  get: function get() {
    return _brandAppleArcade["default"];
  }
});
Object.defineProperty(exports, "BrandApple", {
  enumerable: true,
  get: function get() {
    return _brandApple["default"];
  }
});
Object.defineProperty(exports, "BrandAppstore", {
  enumerable: true,
  get: function get() {
    return _brandAppstore["default"];
  }
});
Object.defineProperty(exports, "BrandBehance", {
  enumerable: true,
  get: function get() {
    return _brandBehance["default"];
  }
});
Object.defineProperty(exports, "BrandChrome", {
  enumerable: true,
  get: function get() {
    return _brandChrome["default"];
  }
});
Object.defineProperty(exports, "BrandCodepen", {
  enumerable: true,
  get: function get() {
    return _brandCodepen["default"];
  }
});
Object.defineProperty(exports, "BrandCodesandbox", {
  enumerable: true,
  get: function get() {
    return _brandCodesandbox["default"];
  }
});
Object.defineProperty(exports, "BrandCss3", {
  enumerable: true,
  get: function get() {
    return _brandCss["default"];
  }
});
Object.defineProperty(exports, "BrandDeviantart", {
  enumerable: true,
  get: function get() {
    return _brandDeviantart["default"];
  }
});
Object.defineProperty(exports, "BrandDiscord", {
  enumerable: true,
  get: function get() {
    return _brandDiscord["default"];
  }
});
Object.defineProperty(exports, "BrandDribbble", {
  enumerable: true,
  get: function get() {
    return _brandDribbble["default"];
  }
});
Object.defineProperty(exports, "BrandEdge", {
  enumerable: true,
  get: function get() {
    return _brandEdge["default"];
  }
});
Object.defineProperty(exports, "BrandFacebook", {
  enumerable: true,
  get: function get() {
    return _brandFacebook["default"];
  }
});
Object.defineProperty(exports, "BrandFigma", {
  enumerable: true,
  get: function get() {
    return _brandFigma["default"];
  }
});
Object.defineProperty(exports, "BrandFirefox", {
  enumerable: true,
  get: function get() {
    return _brandFirefox["default"];
  }
});
Object.defineProperty(exports, "BrandFlickr", {
  enumerable: true,
  get: function get() {
    return _brandFlickr["default"];
  }
});
Object.defineProperty(exports, "BrandFoursquare", {
  enumerable: true,
  get: function get() {
    return _brandFoursquare["default"];
  }
});
Object.defineProperty(exports, "BrandFramer", {
  enumerable: true,
  get: function get() {
    return _brandFramer["default"];
  }
});
Object.defineProperty(exports, "BrandGithub", {
  enumerable: true,
  get: function get() {
    return _brandGithub["default"];
  }
});
Object.defineProperty(exports, "BrandGitlab", {
  enumerable: true,
  get: function get() {
    return _brandGitlab["default"];
  }
});
Object.defineProperty(exports, "BrandGoogleDrive", {
  enumerable: true,
  get: function get() {
    return _brandGoogleDrive["default"];
  }
});
Object.defineProperty(exports, "BrandGooglePlay", {
  enumerable: true,
  get: function get() {
    return _brandGooglePlay["default"];
  }
});
Object.defineProperty(exports, "BrandGoogle", {
  enumerable: true,
  get: function get() {
    return _brandGoogle["default"];
  }
});
Object.defineProperty(exports, "BrandHtml5", {
  enumerable: true,
  get: function get() {
    return _brandHtml["default"];
  }
});
Object.defineProperty(exports, "BrandInstagram", {
  enumerable: true,
  get: function get() {
    return _brandInstagram["default"];
  }
});
Object.defineProperty(exports, "BrandKotlin", {
  enumerable: true,
  get: function get() {
    return _brandKotlin["default"];
  }
});
Object.defineProperty(exports, "BrandLinkedin", {
  enumerable: true,
  get: function get() {
    return _brandLinkedin["default"];
  }
});
Object.defineProperty(exports, "BrandMedium", {
  enumerable: true,
  get: function get() {
    return _brandMedium["default"];
  }
});
Object.defineProperty(exports, "BrandMessenger", {
  enumerable: true,
  get: function get() {
    return _brandMessenger["default"];
  }
});
Object.defineProperty(exports, "BrandOpera", {
  enumerable: true,
  get: function get() {
    return _brandOpera["default"];
  }
});
Object.defineProperty(exports, "BrandPaypal", {
  enumerable: true,
  get: function get() {
    return _brandPaypal["default"];
  }
});
Object.defineProperty(exports, "BrandPinterest", {
  enumerable: true,
  get: function get() {
    return _brandPinterest["default"];
  }
});
Object.defineProperty(exports, "BrandPocket", {
  enumerable: true,
  get: function get() {
    return _brandPocket["default"];
  }
});
Object.defineProperty(exports, "BrandPython", {
  enumerable: true,
  get: function get() {
    return _brandPython["default"];
  }
});
Object.defineProperty(exports, "BrandReddit", {
  enumerable: true,
  get: function get() {
    return _brandReddit["default"];
  }
});
Object.defineProperty(exports, "BrandSafari", {
  enumerable: true,
  get: function get() {
    return _brandSafari["default"];
  }
});
Object.defineProperty(exports, "BrandSketch", {
  enumerable: true,
  get: function get() {
    return _brandSketch["default"];
  }
});
Object.defineProperty(exports, "BrandSkype", {
  enumerable: true,
  get: function get() {
    return _brandSkype["default"];
  }
});
Object.defineProperty(exports, "BrandSlack", {
  enumerable: true,
  get: function get() {
    return _brandSlack["default"];
  }
});
Object.defineProperty(exports, "BrandSnapchat", {
  enumerable: true,
  get: function get() {
    return _brandSnapchat["default"];
  }
});
Object.defineProperty(exports, "BrandSoundcloud", {
  enumerable: true,
  get: function get() {
    return _brandSoundcloud["default"];
  }
});
Object.defineProperty(exports, "BrandSpotify", {
  enumerable: true,
  get: function get() {
    return _brandSpotify["default"];
  }
});
Object.defineProperty(exports, "BrandSteam", {
  enumerable: true,
  get: function get() {
    return _brandSteam["default"];
  }
});
Object.defineProperty(exports, "BrandTabler", {
  enumerable: true,
  get: function get() {
    return _brandTabler["default"];
  }
});
Object.defineProperty(exports, "BrandTailwind", {
  enumerable: true,
  get: function get() {
    return _brandTailwind["default"];
  }
});
Object.defineProperty(exports, "BrandTelegram", {
  enumerable: true,
  get: function get() {
    return _brandTelegram["default"];
  }
});
Object.defineProperty(exports, "BrandTidal", {
  enumerable: true,
  get: function get() {
    return _brandTidal["default"];
  }
});
Object.defineProperty(exports, "BrandTiktok", {
  enumerable: true,
  get: function get() {
    return _brandTiktok["default"];
  }
});
Object.defineProperty(exports, "BrandTinder", {
  enumerable: true,
  get: function get() {
    return _brandTinder["default"];
  }
});
Object.defineProperty(exports, "BrandTumblr", {
  enumerable: true,
  get: function get() {
    return _brandTumblr["default"];
  }
});
Object.defineProperty(exports, "BrandTwitch", {
  enumerable: true,
  get: function get() {
    return _brandTwitch["default"];
  }
});
Object.defineProperty(exports, "BrandTwitter", {
  enumerable: true,
  get: function get() {
    return _brandTwitter["default"];
  }
});
Object.defineProperty(exports, "BrandVimeo", {
  enumerable: true,
  get: function get() {
    return _brandVimeo["default"];
  }
});
Object.defineProperty(exports, "BrandVk", {
  enumerable: true,
  get: function get() {
    return _brandVk["default"];
  }
});
Object.defineProperty(exports, "BrandWhatsapp", {
  enumerable: true,
  get: function get() {
    return _brandWhatsapp["default"];
  }
});
Object.defineProperty(exports, "BrandWindows", {
  enumerable: true,
  get: function get() {
    return _brandWindows["default"];
  }
});
Object.defineProperty(exports, "BrandYahoo", {
  enumerable: true,
  get: function get() {
    return _brandYahoo["default"];
  }
});
Object.defineProperty(exports, "BrandYoutube", {
  enumerable: true,
  get: function get() {
    return _brandYoutube["default"];
  }
});
Object.defineProperty(exports, "Briefcase", {
  enumerable: true,
  get: function get() {
    return _briefcase["default"];
  }
});
Object.defineProperty(exports, "BrightnessDown", {
  enumerable: true,
  get: function get() {
    return _brightnessDown["default"];
  }
});
Object.defineProperty(exports, "BrightnessUp", {
  enumerable: true,
  get: function get() {
    return _brightnessUp["default"];
  }
});
Object.defineProperty(exports, "Brightness", {
  enumerable: true,
  get: function get() {
    return _brightness["default"];
  }
});
Object.defineProperty(exports, "Browser", {
  enumerable: true,
  get: function get() {
    return _browser["default"];
  }
});
Object.defineProperty(exports, "Brush", {
  enumerable: true,
  get: function get() {
    return _brush["default"];
  }
});
Object.defineProperty(exports, "Bucket", {
  enumerable: true,
  get: function get() {
    return _bucket["default"];
  }
});
Object.defineProperty(exports, "Bug", {
  enumerable: true,
  get: function get() {
    return _bug["default"];
  }
});
Object.defineProperty(exports, "BuildingArch", {
  enumerable: true,
  get: function get() {
    return _buildingArch["default"];
  }
});
Object.defineProperty(exports, "BuildingBank", {
  enumerable: true,
  get: function get() {
    return _buildingBank["default"];
  }
});
Object.defineProperty(exports, "BuildingBridge2", {
  enumerable: true,
  get: function get() {
    return _buildingBridge["default"];
  }
});
Object.defineProperty(exports, "BuildingBridge", {
  enumerable: true,
  get: function get() {
    return _buildingBridge2["default"];
  }
});
Object.defineProperty(exports, "BuildingCarousel", {
  enumerable: true,
  get: function get() {
    return _buildingCarousel["default"];
  }
});
Object.defineProperty(exports, "BuildingCastle", {
  enumerable: true,
  get: function get() {
    return _buildingCastle["default"];
  }
});
Object.defineProperty(exports, "BuildingChurch", {
  enumerable: true,
  get: function get() {
    return _buildingChurch["default"];
  }
});
Object.defineProperty(exports, "BuildingCommunity", {
  enumerable: true,
  get: function get() {
    return _buildingCommunity["default"];
  }
});
Object.defineProperty(exports, "BuildingFortress", {
  enumerable: true,
  get: function get() {
    return _buildingFortress["default"];
  }
});
Object.defineProperty(exports, "BuildingHospital", {
  enumerable: true,
  get: function get() {
    return _buildingHospital["default"];
  }
});
Object.defineProperty(exports, "BuildingLighthouse", {
  enumerable: true,
  get: function get() {
    return _buildingLighthouse["default"];
  }
});
Object.defineProperty(exports, "BuildingMonument", {
  enumerable: true,
  get: function get() {
    return _buildingMonument["default"];
  }
});
Object.defineProperty(exports, "BuildingPavilon", {
  enumerable: true,
  get: function get() {
    return _buildingPavilon["default"];
  }
});
Object.defineProperty(exports, "BuildingSkyscraper", {
  enumerable: true,
  get: function get() {
    return _buildingSkyscraper["default"];
  }
});
Object.defineProperty(exports, "BuildingStore", {
  enumerable: true,
  get: function get() {
    return _buildingStore["default"];
  }
});
Object.defineProperty(exports, "BuildingWarehouse", {
  enumerable: true,
  get: function get() {
    return _buildingWarehouse["default"];
  }
});
Object.defineProperty(exports, "Building", {
  enumerable: true,
  get: function get() {
    return _building["default"];
  }
});
Object.defineProperty(exports, "BulbOff", {
  enumerable: true,
  get: function get() {
    return _bulbOff["default"];
  }
});
Object.defineProperty(exports, "Bulb", {
  enumerable: true,
  get: function get() {
    return _bulb["default"];
  }
});
Object.defineProperty(exports, "Buldozer", {
  enumerable: true,
  get: function get() {
    return _buldozer["default"];
  }
});
Object.defineProperty(exports, "Bus", {
  enumerable: true,
  get: function get() {
    return _bus["default"];
  }
});
Object.defineProperty(exports, "Calculator", {
  enumerable: true,
  get: function get() {
    return _calculator["default"];
  }
});
Object.defineProperty(exports, "CalendarEvent", {
  enumerable: true,
  get: function get() {
    return _calendarEvent["default"];
  }
});
Object.defineProperty(exports, "CalendarMinus", {
  enumerable: true,
  get: function get() {
    return _calendarMinus["default"];
  }
});
Object.defineProperty(exports, "CalendarPlus", {
  enumerable: true,
  get: function get() {
    return _calendarPlus["default"];
  }
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _calendar["default"];
  }
});
Object.defineProperty(exports, "CameraMinus", {
  enumerable: true,
  get: function get() {
    return _cameraMinus["default"];
  }
});
Object.defineProperty(exports, "CameraOff", {
  enumerable: true,
  get: function get() {
    return _cameraOff["default"];
  }
});
Object.defineProperty(exports, "CameraPlus", {
  enumerable: true,
  get: function get() {
    return _cameraPlus["default"];
  }
});
Object.defineProperty(exports, "Camera", {
  enumerable: true,
  get: function get() {
    return _camera["default"];
  }
});
Object.defineProperty(exports, "Capture", {
  enumerable: true,
  get: function get() {
    return _capture["default"];
  }
});
Object.defineProperty(exports, "Car", {
  enumerable: true,
  get: function get() {
    return _car["default"];
  }
});
Object.defineProperty(exports, "Caravan", {
  enumerable: true,
  get: function get() {
    return _caravan["default"];
  }
});
Object.defineProperty(exports, "Cardboards", {
  enumerable: true,
  get: function get() {
    return _cardboards["default"];
  }
});
Object.defineProperty(exports, "CaretDown", {
  enumerable: true,
  get: function get() {
    return _caretDown["default"];
  }
});
Object.defineProperty(exports, "CaretLeft", {
  enumerable: true,
  get: function get() {
    return _caretLeft["default"];
  }
});
Object.defineProperty(exports, "CaretRight", {
  enumerable: true,
  get: function get() {
    return _caretRight["default"];
  }
});
Object.defineProperty(exports, "CaretUp", {
  enumerable: true,
  get: function get() {
    return _caretUp["default"];
  }
});
Object.defineProperty(exports, "Cash", {
  enumerable: true,
  get: function get() {
    return _cash["default"];
  }
});
Object.defineProperty(exports, "Cast", {
  enumerable: true,
  get: function get() {
    return _cast["default"];
  }
});
Object.defineProperty(exports, "Ce", {
  enumerable: true,
  get: function get() {
    return _ce["default"];
  }
});
Object.defineProperty(exports, "Certificate", {
  enumerable: true,
  get: function get() {
    return _certificate["default"];
  }
});
Object.defineProperty(exports, "ChartAreaLine", {
  enumerable: true,
  get: function get() {
    return _chartAreaLine["default"];
  }
});
Object.defineProperty(exports, "ChartArea", {
  enumerable: true,
  get: function get() {
    return _chartArea["default"];
  }
});
Object.defineProperty(exports, "ChartBar", {
  enumerable: true,
  get: function get() {
    return _chartBar["default"];
  }
});
Object.defineProperty(exports, "ChartBubble", {
  enumerable: true,
  get: function get() {
    return _chartBubble["default"];
  }
});
Object.defineProperty(exports, "ChartCandle", {
  enumerable: true,
  get: function get() {
    return _chartCandle["default"];
  }
});
Object.defineProperty(exports, "ChartDonut", {
  enumerable: true,
  get: function get() {
    return _chartDonut["default"];
  }
});
Object.defineProperty(exports, "ChartLine", {
  enumerable: true,
  get: function get() {
    return _chartLine["default"];
  }
});
Object.defineProperty(exports, "ChartPie", {
  enumerable: true,
  get: function get() {
    return _chartPie["default"];
  }
});
Object.defineProperty(exports, "ChartRadar", {
  enumerable: true,
  get: function get() {
    return _chartRadar["default"];
  }
});
Object.defineProperty(exports, "Check", {
  enumerable: true,
  get: function get() {
    return _check["default"];
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function get() {
    return _checkbox["default"];
  }
});
Object.defineProperty(exports, "Checks", {
  enumerable: true,
  get: function get() {
    return _checks["default"];
  }
});
Object.defineProperty(exports, "ChevronDownLeft", {
  enumerable: true,
  get: function get() {
    return _chevronDownLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronDownRight", {
  enumerable: true,
  get: function get() {
    return _chevronDownRight["default"];
  }
});
Object.defineProperty(exports, "ChevronDown", {
  enumerable: true,
  get: function get() {
    return _chevronDown["default"];
  }
});
Object.defineProperty(exports, "ChevronLeft", {
  enumerable: true,
  get: function get() {
    return _chevronLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronRight", {
  enumerable: true,
  get: function get() {
    return _chevronRight["default"];
  }
});
Object.defineProperty(exports, "ChevronUpLeft", {
  enumerable: true,
  get: function get() {
    return _chevronUpLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronUpRight", {
  enumerable: true,
  get: function get() {
    return _chevronUpRight["default"];
  }
});
Object.defineProperty(exports, "ChevronUp", {
  enumerable: true,
  get: function get() {
    return _chevronUp["default"];
  }
});
Object.defineProperty(exports, "ChevronsDownLeft", {
  enumerable: true,
  get: function get() {
    return _chevronsDownLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronsDownRight", {
  enumerable: true,
  get: function get() {
    return _chevronsDownRight["default"];
  }
});
Object.defineProperty(exports, "ChevronsDown", {
  enumerable: true,
  get: function get() {
    return _chevronsDown["default"];
  }
});
Object.defineProperty(exports, "ChevronsLeft", {
  enumerable: true,
  get: function get() {
    return _chevronsLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronsRight", {
  enumerable: true,
  get: function get() {
    return _chevronsRight["default"];
  }
});
Object.defineProperty(exports, "ChevronsUpLeft", {
  enumerable: true,
  get: function get() {
    return _chevronsUpLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronsUpRight", {
  enumerable: true,
  get: function get() {
    return _chevronsUpRight["default"];
  }
});
Object.defineProperty(exports, "ChevronsUp", {
  enumerable: true,
  get: function get() {
    return _chevronsUp["default"];
  }
});
Object.defineProperty(exports, "ChristmasTree", {
  enumerable: true,
  get: function get() {
    return _christmasTree["default"];
  }
});
Object.defineProperty(exports, "CircleCheck", {
  enumerable: true,
  get: function get() {
    return _circleCheck["default"];
  }
});
Object.defineProperty(exports, "CircleDashed", {
  enumerable: true,
  get: function get() {
    return _circleDashed["default"];
  }
});
Object.defineProperty(exports, "CircleDotted", {
  enumerable: true,
  get: function get() {
    return _circleDotted["default"];
  }
});
Object.defineProperty(exports, "CircleMinus", {
  enumerable: true,
  get: function get() {
    return _circleMinus["default"];
  }
});
Object.defineProperty(exports, "CirclePlus", {
  enumerable: true,
  get: function get() {
    return _circlePlus["default"];
  }
});
Object.defineProperty(exports, "CircleSquare", {
  enumerable: true,
  get: function get() {
    return _circleSquare["default"];
  }
});
Object.defineProperty(exports, "CircleX", {
  enumerable: true,
  get: function get() {
    return _circleX["default"];
  }
});
Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _circle["default"];
  }
});
Object.defineProperty(exports, "Circles", {
  enumerable: true,
  get: function get() {
    return _circles["default"];
  }
});
Object.defineProperty(exports, "ClearFormatting", {
  enumerable: true,
  get: function get() {
    return _clearFormatting["default"];
  }
});
Object.defineProperty(exports, "Click", {
  enumerable: true,
  get: function get() {
    return _click["default"];
  }
});
Object.defineProperty(exports, "ClipboardCheck", {
  enumerable: true,
  get: function get() {
    return _clipboardCheck["default"];
  }
});
Object.defineProperty(exports, "ClipboardList", {
  enumerable: true,
  get: function get() {
    return _clipboardList["default"];
  }
});
Object.defineProperty(exports, "ClipboardX", {
  enumerable: true,
  get: function get() {
    return _clipboardX["default"];
  }
});
Object.defineProperty(exports, "Clipboard", {
  enumerable: true,
  get: function get() {
    return _clipboard["default"];
  }
});
Object.defineProperty(exports, "Clock", {
  enumerable: true,
  get: function get() {
    return _clock["default"];
  }
});
Object.defineProperty(exports, "CloudDownload", {
  enumerable: true,
  get: function get() {
    return _cloudDownload["default"];
  }
});
Object.defineProperty(exports, "CloudFog", {
  enumerable: true,
  get: function get() {
    return _cloudFog["default"];
  }
});
Object.defineProperty(exports, "CloudOff", {
  enumerable: true,
  get: function get() {
    return _cloudOff["default"];
  }
});
Object.defineProperty(exports, "CloudRain", {
  enumerable: true,
  get: function get() {
    return _cloudRain["default"];
  }
});
Object.defineProperty(exports, "CloudSnow", {
  enumerable: true,
  get: function get() {
    return _cloudSnow["default"];
  }
});
Object.defineProperty(exports, "CloudStorm", {
  enumerable: true,
  get: function get() {
    return _cloudStorm["default"];
  }
});
Object.defineProperty(exports, "CloudUpload", {
  enumerable: true,
  get: function get() {
    return _cloudUpload["default"];
  }
});
Object.defineProperty(exports, "Cloud", {
  enumerable: true,
  get: function get() {
    return _cloud["default"];
  }
});
Object.defineProperty(exports, "Code", {
  enumerable: true,
  get: function get() {
    return _code["default"];
  }
});
Object.defineProperty(exports, "Coin", {
  enumerable: true,
  get: function get() {
    return _coin["default"];
  }
});
Object.defineProperty(exports, "ColorPicker", {
  enumerable: true,
  get: function get() {
    return _colorPicker["default"];
  }
});
Object.defineProperty(exports, "ColorSwatch", {
  enumerable: true,
  get: function get() {
    return _colorSwatch["default"];
  }
});
Object.defineProperty(exports, "Columns", {
  enumerable: true,
  get: function get() {
    return _columns["default"];
  }
});
Object.defineProperty(exports, "Comet", {
  enumerable: true,
  get: function get() {
    return _comet["default"];
  }
});
Object.defineProperty(exports, "Command", {
  enumerable: true,
  get: function get() {
    return _command["default"];
  }
});
Object.defineProperty(exports, "Compass", {
  enumerable: true,
  get: function get() {
    return _compass["default"];
  }
});
Object.defineProperty(exports, "Contrast", {
  enumerable: true,
  get: function get() {
    return _contrast["default"];
  }
});
Object.defineProperty(exports, "Copy", {
  enumerable: true,
  get: function get() {
    return _copy["default"];
  }
});
Object.defineProperty(exports, "Copyleft", {
  enumerable: true,
  get: function get() {
    return _copyleft["default"];
  }
});
Object.defineProperty(exports, "Copyright", {
  enumerable: true,
  get: function get() {
    return _copyright["default"];
  }
});
Object.defineProperty(exports, "CornerDownLeft", {
  enumerable: true,
  get: function get() {
    return _cornerDownLeft["default"];
  }
});
Object.defineProperty(exports, "CornerDownRight", {
  enumerable: true,
  get: function get() {
    return _cornerDownRight["default"];
  }
});
Object.defineProperty(exports, "CornerLeftDown", {
  enumerable: true,
  get: function get() {
    return _cornerLeftDown["default"];
  }
});
Object.defineProperty(exports, "CornerLeftUp", {
  enumerable: true,
  get: function get() {
    return _cornerLeftUp["default"];
  }
});
Object.defineProperty(exports, "CornerRightDown", {
  enumerable: true,
  get: function get() {
    return _cornerRightDown["default"];
  }
});
Object.defineProperty(exports, "CornerRightUp", {
  enumerable: true,
  get: function get() {
    return _cornerRightUp["default"];
  }
});
Object.defineProperty(exports, "CornerUpLeft", {
  enumerable: true,
  get: function get() {
    return _cornerUpLeft["default"];
  }
});
Object.defineProperty(exports, "CornerUpRight", {
  enumerable: true,
  get: function get() {
    return _cornerUpRight["default"];
  }
});
Object.defineProperty(exports, "CreditCardOff", {
  enumerable: true,
  get: function get() {
    return _creditCardOff["default"];
  }
});
Object.defineProperty(exports, "CreditCard", {
  enumerable: true,
  get: function get() {
    return _creditCard["default"];
  }
});
Object.defineProperty(exports, "Crop", {
  enumerable: true,
  get: function get() {
    return _crop["default"];
  }
});
Object.defineProperty(exports, "Crosshair", {
  enumerable: true,
  get: function get() {
    return _crosshair["default"];
  }
});
Object.defineProperty(exports, "Crown", {
  enumerable: true,
  get: function get() {
    return _crown["default"];
  }
});
Object.defineProperty(exports, "CurlyLoop", {
  enumerable: true,
  get: function get() {
    return _curlyLoop["default"];
  }
});
Object.defineProperty(exports, "CurrencyBitcoin", {
  enumerable: true,
  get: function get() {
    return _currencyBitcoin["default"];
  }
});
Object.defineProperty(exports, "CurrencyDollar", {
  enumerable: true,
  get: function get() {
    return _currencyDollar["default"];
  }
});
Object.defineProperty(exports, "CurrencyEuro", {
  enumerable: true,
  get: function get() {
    return _currencyEuro["default"];
  }
});
Object.defineProperty(exports, "CurrencyPound", {
  enumerable: true,
  get: function get() {
    return _currencyPound["default"];
  }
});
Object.defineProperty(exports, "CurrencyRupee", {
  enumerable: true,
  get: function get() {
    return _currencyRupee["default"];
  }
});
Object.defineProperty(exports, "CurrencyYen", {
  enumerable: true,
  get: function get() {
    return _currencyYen["default"];
  }
});
Object.defineProperty(exports, "CurrentLocation", {
  enumerable: true,
  get: function get() {
    return _currentLocation["default"];
  }
});
Object.defineProperty(exports, "Cut", {
  enumerable: true,
  get: function get() {
    return _cut["default"];
  }
});
Object.defineProperty(exports, "Dashboard", {
  enumerable: true,
  get: function get() {
    return _dashboard["default"];
  }
});
Object.defineProperty(exports, "Database", {
  enumerable: true,
  get: function get() {
    return _database["default"];
  }
});
Object.defineProperty(exports, "DeviceDesktop", {
  enumerable: true,
  get: function get() {
    return _deviceDesktop["default"];
  }
});
Object.defineProperty(exports, "DeviceFloppy", {
  enumerable: true,
  get: function get() {
    return _deviceFloppy["default"];
  }
});
Object.defineProperty(exports, "DeviceGamepad", {
  enumerable: true,
  get: function get() {
    return _deviceGamepad["default"];
  }
});
Object.defineProperty(exports, "DeviceLaptop", {
  enumerable: true,
  get: function get() {
    return _deviceLaptop["default"];
  }
});
Object.defineProperty(exports, "DeviceMobileRotated", {
  enumerable: true,
  get: function get() {
    return _deviceMobileRotated["default"];
  }
});
Object.defineProperty(exports, "DeviceMobileVibration", {
  enumerable: true,
  get: function get() {
    return _deviceMobileVibration["default"];
  }
});
Object.defineProperty(exports, "DeviceMobile", {
  enumerable: true,
  get: function get() {
    return _deviceMobile["default"];
  }
});
Object.defineProperty(exports, "DeviceSpeaker", {
  enumerable: true,
  get: function get() {
    return _deviceSpeaker["default"];
  }
});
Object.defineProperty(exports, "DeviceTablet", {
  enumerable: true,
  get: function get() {
    return _deviceTablet["default"];
  }
});
Object.defineProperty(exports, "DeviceTv", {
  enumerable: true,
  get: function get() {
    return _deviceTv["default"];
  }
});
Object.defineProperty(exports, "DeviceWatch", {
  enumerable: true,
  get: function get() {
    return _deviceWatch["default"];
  }
});
Object.defineProperty(exports, "Devices2", {
  enumerable: true,
  get: function get() {
    return _devices["default"];
  }
});
Object.defineProperty(exports, "Devices", {
  enumerable: true,
  get: function get() {
    return _devices2["default"];
  }
});
Object.defineProperty(exports, "Diamond", {
  enumerable: true,
  get: function get() {
    return _diamond["default"];
  }
});
Object.defineProperty(exports, "Dice", {
  enumerable: true,
  get: function get() {
    return _dice["default"];
  }
});
Object.defineProperty(exports, "DirectionHorizontal", {
  enumerable: true,
  get: function get() {
    return _directionHorizontal["default"];
  }
});
Object.defineProperty(exports, "Direction", {
  enumerable: true,
  get: function get() {
    return _direction["default"];
  }
});
Object.defineProperty(exports, "Directions", {
  enumerable: true,
  get: function get() {
    return _directions["default"];
  }
});
Object.defineProperty(exports, "Disabled2", {
  enumerable: true,
  get: function get() {
    return _disabled["default"];
  }
});
Object.defineProperty(exports, "Disabled", {
  enumerable: true,
  get: function get() {
    return _disabled2["default"];
  }
});
Object.defineProperty(exports, "Disc", {
  enumerable: true,
  get: function get() {
    return _disc["default"];
  }
});
Object.defineProperty(exports, "Discount", {
  enumerable: true,
  get: function get() {
    return _discount["default"];
  }
});
Object.defineProperty(exports, "Divide", {
  enumerable: true,
  get: function get() {
    return _divide["default"];
  }
});
Object.defineProperty(exports, "DotsCircleHorizontal", {
  enumerable: true,
  get: function get() {
    return _dotsCircleHorizontal["default"];
  }
});
Object.defineProperty(exports, "DotsDiagonal2", {
  enumerable: true,
  get: function get() {
    return _dotsDiagonal["default"];
  }
});
Object.defineProperty(exports, "DotsDiagonal", {
  enumerable: true,
  get: function get() {
    return _dotsDiagonal2["default"];
  }
});
Object.defineProperty(exports, "DotsVertical", {
  enumerable: true,
  get: function get() {
    return _dotsVertical["default"];
  }
});
Object.defineProperty(exports, "Dots", {
  enumerable: true,
  get: function get() {
    return _dots["default"];
  }
});
Object.defineProperty(exports, "Download", {
  enumerable: true,
  get: function get() {
    return _download["default"];
  }
});
Object.defineProperty(exports, "DragDrop2", {
  enumerable: true,
  get: function get() {
    return _dragDrop["default"];
  }
});
Object.defineProperty(exports, "DragDrop", {
  enumerable: true,
  get: function get() {
    return _dragDrop2["default"];
  }
});
Object.defineProperty(exports, "Drone", {
  enumerable: true,
  get: function get() {
    return _drone["default"];
  }
});
Object.defineProperty(exports, "Droplet", {
  enumerable: true,
  get: function get() {
    return _droplet["default"];
  }
});
Object.defineProperty(exports, "Ear", {
  enumerable: true,
  get: function get() {
    return _ear["default"];
  }
});
Object.defineProperty(exports, "Edit", {
  enumerable: true,
  get: function get() {
    return _edit["default"];
  }
});
Object.defineProperty(exports, "Egg", {
  enumerable: true,
  get: function get() {
    return _egg["default"];
  }
});
Object.defineProperty(exports, "Emphasis", {
  enumerable: true,
  get: function get() {
    return _emphasis["default"];
  }
});
Object.defineProperty(exports, "Eraser", {
  enumerable: true,
  get: function get() {
    return _eraser["default"];
  }
});
Object.defineProperty(exports, "Exchange", {
  enumerable: true,
  get: function get() {
    return _exchange["default"];
  }
});
Object.defineProperty(exports, "Exposure", {
  enumerable: true,
  get: function get() {
    return _exposure["default"];
  }
});
Object.defineProperty(exports, "ExternalLink", {
  enumerable: true,
  get: function get() {
    return _externalLink["default"];
  }
});
Object.defineProperty(exports, "EyeOff", {
  enumerable: true,
  get: function get() {
    return _eyeOff["default"];
  }
});
Object.defineProperty(exports, "Eye", {
  enumerable: true,
  get: function get() {
    return _eye["default"];
  }
});
Object.defineProperty(exports, "FaceId", {
  enumerable: true,
  get: function get() {
    return _faceId["default"];
  }
});
Object.defineProperty(exports, "Fall", {
  enumerable: true,
  get: function get() {
    return _fall["default"];
  }
});
Object.defineProperty(exports, "FileCertificate", {
  enumerable: true,
  get: function get() {
    return _fileCertificate["default"];
  }
});
Object.defineProperty(exports, "FileCheck", {
  enumerable: true,
  get: function get() {
    return _fileCheck["default"];
  }
});
Object.defineProperty(exports, "FileCode", {
  enumerable: true,
  get: function get() {
    return _fileCode["default"];
  }
});
Object.defineProperty(exports, "FileDiff", {
  enumerable: true,
  get: function get() {
    return _fileDiff["default"];
  }
});
Object.defineProperty(exports, "FileDislike", {
  enumerable: true,
  get: function get() {
    return _fileDislike["default"];
  }
});
Object.defineProperty(exports, "FileDownload", {
  enumerable: true,
  get: function get() {
    return _fileDownload["default"];
  }
});
Object.defineProperty(exports, "FileHorizontal", {
  enumerable: true,
  get: function get() {
    return _fileHorizontal["default"];
  }
});
Object.defineProperty(exports, "FileInvoice", {
  enumerable: true,
  get: function get() {
    return _fileInvoice["default"];
  }
});
Object.defineProperty(exports, "FileLike", {
  enumerable: true,
  get: function get() {
    return _fileLike["default"];
  }
});
Object.defineProperty(exports, "FileMinus", {
  enumerable: true,
  get: function get() {
    return _fileMinus["default"];
  }
});
Object.defineProperty(exports, "FileMusic", {
  enumerable: true,
  get: function get() {
    return _fileMusic["default"];
  }
});
Object.defineProperty(exports, "FileOff", {
  enumerable: true,
  get: function get() {
    return _fileOff["default"];
  }
});
Object.defineProperty(exports, "FilePhone", {
  enumerable: true,
  get: function get() {
    return _filePhone["default"];
  }
});
Object.defineProperty(exports, "FilePlus", {
  enumerable: true,
  get: function get() {
    return _filePlus["default"];
  }
});
Object.defineProperty(exports, "FileSearch", {
  enumerable: true,
  get: function get() {
    return _fileSearch["default"];
  }
});
Object.defineProperty(exports, "FileShredder", {
  enumerable: true,
  get: function get() {
    return _fileShredder["default"];
  }
});
Object.defineProperty(exports, "FileSymlink", {
  enumerable: true,
  get: function get() {
    return _fileSymlink["default"];
  }
});
Object.defineProperty(exports, "FileText", {
  enumerable: true,
  get: function get() {
    return _fileText["default"];
  }
});
Object.defineProperty(exports, "FileUpload", {
  enumerable: true,
  get: function get() {
    return _fileUpload["default"];
  }
});
Object.defineProperty(exports, "FileX", {
  enumerable: true,
  get: function get() {
    return _fileX["default"];
  }
});
Object.defineProperty(exports, "FileZip", {
  enumerable: true,
  get: function get() {
    return _fileZip["default"];
  }
});
Object.defineProperty(exports, "File", {
  enumerable: true,
  get: function get() {
    return _file["default"];
  }
});
Object.defineProperty(exports, "FilterOff", {
  enumerable: true,
  get: function get() {
    return _filterOff["default"];
  }
});
Object.defineProperty(exports, "Filter", {
  enumerable: true,
  get: function get() {
    return _filter["default"];
  }
});
Object.defineProperty(exports, "Fingerprint", {
  enumerable: true,
  get: function get() {
    return _fingerprint["default"];
  }
});
Object.defineProperty(exports, "Firetruck", {
  enumerable: true,
  get: function get() {
    return _firetruck["default"];
  }
});
Object.defineProperty(exports, "Flag", {
  enumerable: true,
  get: function get() {
    return _flag["default"];
  }
});
Object.defineProperty(exports, "Flame", {
  enumerable: true,
  get: function get() {
    return _flame["default"];
  }
});
Object.defineProperty(exports, "Flask", {
  enumerable: true,
  get: function get() {
    return _flask["default"];
  }
});
Object.defineProperty(exports, "FlipHorizontal", {
  enumerable: true,
  get: function get() {
    return _flipHorizontal["default"];
  }
});
Object.defineProperty(exports, "FlipVertical", {
  enumerable: true,
  get: function get() {
    return _flipVertical["default"];
  }
});
Object.defineProperty(exports, "FloatCenter", {
  enumerable: true,
  get: function get() {
    return _floatCenter["default"];
  }
});
Object.defineProperty(exports, "FloatLeft", {
  enumerable: true,
  get: function get() {
    return _floatLeft["default"];
  }
});
Object.defineProperty(exports, "FloatNone", {
  enumerable: true,
  get: function get() {
    return _floatNone["default"];
  }
});
Object.defineProperty(exports, "FloatRight", {
  enumerable: true,
  get: function get() {
    return _floatRight["default"];
  }
});
Object.defineProperty(exports, "Focus2", {
  enumerable: true,
  get: function get() {
    return _focus["default"];
  }
});
Object.defineProperty(exports, "Focus", {
  enumerable: true,
  get: function get() {
    return _focus2["default"];
  }
});
Object.defineProperty(exports, "FoldDown", {
  enumerable: true,
  get: function get() {
    return _foldDown["default"];
  }
});
Object.defineProperty(exports, "FoldUp", {
  enumerable: true,
  get: function get() {
    return _foldUp["default"];
  }
});
Object.defineProperty(exports, "Fold", {
  enumerable: true,
  get: function get() {
    return _fold["default"];
  }
});
Object.defineProperty(exports, "FolderMinus", {
  enumerable: true,
  get: function get() {
    return _folderMinus["default"];
  }
});
Object.defineProperty(exports, "FolderOff", {
  enumerable: true,
  get: function get() {
    return _folderOff["default"];
  }
});
Object.defineProperty(exports, "FolderPlus", {
  enumerable: true,
  get: function get() {
    return _folderPlus["default"];
  }
});
Object.defineProperty(exports, "FolderX", {
  enumerable: true,
  get: function get() {
    return _folderX["default"];
  }
});
Object.defineProperty(exports, "Folder", {
  enumerable: true,
  get: function get() {
    return _folder["default"];
  }
});
Object.defineProperty(exports, "Folders", {
  enumerable: true,
  get: function get() {
    return _folders["default"];
  }
});
Object.defineProperty(exports, "Forbid2", {
  enumerable: true,
  get: function get() {
    return _forbid["default"];
  }
});
Object.defineProperty(exports, "Forbid", {
  enumerable: true,
  get: function get() {
    return _forbid2["default"];
  }
});
Object.defineProperty(exports, "Forklift", {
  enumerable: true,
  get: function get() {
    return _forklift["default"];
  }
});
Object.defineProperty(exports, "Frame", {
  enumerable: true,
  get: function get() {
    return _frame["default"];
  }
});
Object.defineProperty(exports, "Friends", {
  enumerable: true,
  get: function get() {
    return _friends["default"];
  }
});
Object.defineProperty(exports, "GasStation", {
  enumerable: true,
  get: function get() {
    return _gasStation["default"];
  }
});
Object.defineProperty(exports, "Gauge", {
  enumerable: true,
  get: function get() {
    return _gauge["default"];
  }
});
Object.defineProperty(exports, "Ghost", {
  enumerable: true,
  get: function get() {
    return _ghost["default"];
  }
});
Object.defineProperty(exports, "Gift", {
  enumerable: true,
  get: function get() {
    return _gift["default"];
  }
});
Object.defineProperty(exports, "GitBranch", {
  enumerable: true,
  get: function get() {
    return _gitBranch["default"];
  }
});
Object.defineProperty(exports, "GitCommit", {
  enumerable: true,
  get: function get() {
    return _gitCommit["default"];
  }
});
Object.defineProperty(exports, "GitCompare", {
  enumerable: true,
  get: function get() {
    return _gitCompare["default"];
  }
});
Object.defineProperty(exports, "GitFork", {
  enumerable: true,
  get: function get() {
    return _gitFork["default"];
  }
});
Object.defineProperty(exports, "GitMerge", {
  enumerable: true,
  get: function get() {
    return _gitMerge["default"];
  }
});
Object.defineProperty(exports, "GitPullRequest", {
  enumerable: true,
  get: function get() {
    return _gitPullRequest["default"];
  }
});
Object.defineProperty(exports, "GlassFull", {
  enumerable: true,
  get: function get() {
    return _glassFull["default"];
  }
});
Object.defineProperty(exports, "Glass", {
  enumerable: true,
  get: function get() {
    return _glass["default"];
  }
});
Object.defineProperty(exports, "Globe", {
  enumerable: true,
  get: function get() {
    return _globe["default"];
  }
});
Object.defineProperty(exports, "Golf", {
  enumerable: true,
  get: function get() {
    return _golf["default"];
  }
});
Object.defineProperty(exports, "Gps", {
  enumerable: true,
  get: function get() {
    return _gps["default"];
  }
});
Object.defineProperty(exports, "GridDots", {
  enumerable: true,
  get: function get() {
    return _gridDots["default"];
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _grid["default"];
  }
});
Object.defineProperty(exports, "GripHorizontal", {
  enumerable: true,
  get: function get() {
    return _gripHorizontal["default"];
  }
});
Object.defineProperty(exports, "GripVertical", {
  enumerable: true,
  get: function get() {
    return _gripVertical["default"];
  }
});
Object.defineProperty(exports, "H1", {
  enumerable: true,
  get: function get() {
    return _h["default"];
  }
});
Object.defineProperty(exports, "H2", {
  enumerable: true,
  get: function get() {
    return _h2["default"];
  }
});
Object.defineProperty(exports, "H3", {
  enumerable: true,
  get: function get() {
    return _h3["default"];
  }
});
Object.defineProperty(exports, "H4", {
  enumerable: true,
  get: function get() {
    return _h4["default"];
  }
});
Object.defineProperty(exports, "H5", {
  enumerable: true,
  get: function get() {
    return _h5["default"];
  }
});
Object.defineProperty(exports, "H6", {
  enumerable: true,
  get: function get() {
    return _h6["default"];
  }
});
Object.defineProperty(exports, "HandMiddleFinger", {
  enumerable: true,
  get: function get() {
    return _handMiddleFinger["default"];
  }
});
Object.defineProperty(exports, "HandOff", {
  enumerable: true,
  get: function get() {
    return _handOff["default"];
  }
});
Object.defineProperty(exports, "HandStop", {
  enumerable: true,
  get: function get() {
    return _handStop["default"];
  }
});
Object.defineProperty(exports, "Hash", {
  enumerable: true,
  get: function get() {
    return _hash["default"];
  }
});
Object.defineProperty(exports, "HeadphonesOff", {
  enumerable: true,
  get: function get() {
    return _headphonesOff["default"];
  }
});
Object.defineProperty(exports, "Headphones", {
  enumerable: true,
  get: function get() {
    return _headphones["default"];
  }
});
Object.defineProperty(exports, "Headset", {
  enumerable: true,
  get: function get() {
    return _headset["default"];
  }
});
Object.defineProperty(exports, "HeartBroken", {
  enumerable: true,
  get: function get() {
    return _heartBroken["default"];
  }
});
Object.defineProperty(exports, "Heart", {
  enumerable: true,
  get: function get() {
    return _heart["default"];
  }
});
Object.defineProperty(exports, "HelicopterLanding", {
  enumerable: true,
  get: function get() {
    return _helicopterLanding["default"];
  }
});
Object.defineProperty(exports, "Helicopter", {
  enumerable: true,
  get: function get() {
    return _helicopter["default"];
  }
});
Object.defineProperty(exports, "Help", {
  enumerable: true,
  get: function get() {
    return _help["default"];
  }
});
Object.defineProperty(exports, "Hexagon", {
  enumerable: true,
  get: function get() {
    return _hexagon["default"];
  }
});
Object.defineProperty(exports, "History", {
  enumerable: true,
  get: function get() {
    return _history["default"];
  }
});
Object.defineProperty(exports, "Home2", {
  enumerable: true,
  get: function get() {
    return _home["default"];
  }
});
Object.defineProperty(exports, "Home", {
  enumerable: true,
  get: function get() {
    return _home2["default"];
  }
});
Object.defineProperty(exports, "IceCream", {
  enumerable: true,
  get: function get() {
    return _iceCream["default"];
  }
});
Object.defineProperty(exports, "Id", {
  enumerable: true,
  get: function get() {
    return _id["default"];
  }
});
Object.defineProperty(exports, "Inbox", {
  enumerable: true,
  get: function get() {
    return _inbox["default"];
  }
});
Object.defineProperty(exports, "IndentDecrease", {
  enumerable: true,
  get: function get() {
    return _indentDecrease["default"];
  }
});
Object.defineProperty(exports, "IndentIncrease", {
  enumerable: true,
  get: function get() {
    return _indentIncrease["default"];
  }
});
Object.defineProperty(exports, "Infinity", {
  enumerable: true,
  get: function get() {
    return _infinity["default"];
  }
});
Object.defineProperty(exports, "InfoCircle", {
  enumerable: true,
  get: function get() {
    return _infoCircle["default"];
  }
});
Object.defineProperty(exports, "InfoSquare", {
  enumerable: true,
  get: function get() {
    return _infoSquare["default"];
  }
});
Object.defineProperty(exports, "Italic", {
  enumerable: true,
  get: function get() {
    return _italic["default"];
  }
});
Object.defineProperty(exports, "JumpRope", {
  enumerable: true,
  get: function get() {
    return _jumpRope["default"];
  }
});
Object.defineProperty(exports, "Karate", {
  enumerable: true,
  get: function get() {
    return _karate["default"];
  }
});
Object.defineProperty(exports, "Key", {
  enumerable: true,
  get: function get() {
    return _key["default"];
  }
});
Object.defineProperty(exports, "KeyboardHide", {
  enumerable: true,
  get: function get() {
    return _keyboardHide["default"];
  }
});
Object.defineProperty(exports, "KeyboardShow", {
  enumerable: true,
  get: function get() {
    return _keyboardShow["default"];
  }
});
Object.defineProperty(exports, "Keyboard", {
  enumerable: true,
  get: function get() {
    return _keyboard["default"];
  }
});
Object.defineProperty(exports, "Language", {
  enumerable: true,
  get: function get() {
    return _language["default"];
  }
});
Object.defineProperty(exports, "LayersDifference", {
  enumerable: true,
  get: function get() {
    return _layersDifference["default"];
  }
});
Object.defineProperty(exports, "LayersIntersect", {
  enumerable: true,
  get: function get() {
    return _layersIntersect["default"];
  }
});
Object.defineProperty(exports, "LayersSubtract", {
  enumerable: true,
  get: function get() {
    return _layersSubtract["default"];
  }
});
Object.defineProperty(exports, "LayersUnion", {
  enumerable: true,
  get: function get() {
    return _layersUnion["default"];
  }
});
Object.defineProperty(exports, "Layout2", {
  enumerable: true,
  get: function get() {
    return _layout["default"];
  }
});
Object.defineProperty(exports, "LayoutAlignBottom", {
  enumerable: true,
  get: function get() {
    return _layoutAlignBottom["default"];
  }
});
Object.defineProperty(exports, "LayoutAlignCenter", {
  enumerable: true,
  get: function get() {
    return _layoutAlignCenter["default"];
  }
});
Object.defineProperty(exports, "LayoutAlignLeft", {
  enumerable: true,
  get: function get() {
    return _layoutAlignLeft["default"];
  }
});
Object.defineProperty(exports, "LayoutAlignMiddle", {
  enumerable: true,
  get: function get() {
    return _layoutAlignMiddle["default"];
  }
});
Object.defineProperty(exports, "LayoutAlignRight", {
  enumerable: true,
  get: function get() {
    return _layoutAlignRight["default"];
  }
});
Object.defineProperty(exports, "LayoutAlignTop", {
  enumerable: true,
  get: function get() {
    return _layoutAlignTop["default"];
  }
});
Object.defineProperty(exports, "LayoutBottombar", {
  enumerable: true,
  get: function get() {
    return _layoutBottombar["default"];
  }
});
Object.defineProperty(exports, "LayoutCards", {
  enumerable: true,
  get: function get() {
    return _layoutCards["default"];
  }
});
Object.defineProperty(exports, "LayoutColumns", {
  enumerable: true,
  get: function get() {
    return _layoutColumns["default"];
  }
});
Object.defineProperty(exports, "LayoutDistributeHorizontal", {
  enumerable: true,
  get: function get() {
    return _layoutDistributeHorizontal["default"];
  }
});
Object.defineProperty(exports, "LayoutDistributeVertical", {
  enumerable: true,
  get: function get() {
    return _layoutDistributeVertical["default"];
  }
});
Object.defineProperty(exports, "LayoutKanban", {
  enumerable: true,
  get: function get() {
    return _layoutKanban["default"];
  }
});
Object.defineProperty(exports, "LayoutList", {
  enumerable: true,
  get: function get() {
    return _layoutList["default"];
  }
});
Object.defineProperty(exports, "LayoutNavbar", {
  enumerable: true,
  get: function get() {
    return _layoutNavbar["default"];
  }
});
Object.defineProperty(exports, "LayoutRows", {
  enumerable: true,
  get: function get() {
    return _layoutRows["default"];
  }
});
Object.defineProperty(exports, "LayoutSidebarRight", {
  enumerable: true,
  get: function get() {
    return _layoutSidebarRight["default"];
  }
});
Object.defineProperty(exports, "LayoutSidebar", {
  enumerable: true,
  get: function get() {
    return _layoutSidebar["default"];
  }
});
Object.defineProperty(exports, "Layout", {
  enumerable: true,
  get: function get() {
    return _layout2["default"];
  }
});
Object.defineProperty(exports, "Leaf", {
  enumerable: true,
  get: function get() {
    return _leaf["default"];
  }
});
Object.defineProperty(exports, "Lego", {
  enumerable: true,
  get: function get() {
    return _lego["default"];
  }
});
Object.defineProperty(exports, "LetterA", {
  enumerable: true,
  get: function get() {
    return _letterA["default"];
  }
});
Object.defineProperty(exports, "LetterB", {
  enumerable: true,
  get: function get() {
    return _letterB["default"];
  }
});
Object.defineProperty(exports, "LetterC", {
  enumerable: true,
  get: function get() {
    return _letterC["default"];
  }
});
Object.defineProperty(exports, "LetterD", {
  enumerable: true,
  get: function get() {
    return _letterD["default"];
  }
});
Object.defineProperty(exports, "LetterE", {
  enumerable: true,
  get: function get() {
    return _letterE["default"];
  }
});
Object.defineProperty(exports, "LetterF", {
  enumerable: true,
  get: function get() {
    return _letterF["default"];
  }
});
Object.defineProperty(exports, "LetterG", {
  enumerable: true,
  get: function get() {
    return _letterG["default"];
  }
});
Object.defineProperty(exports, "LetterH", {
  enumerable: true,
  get: function get() {
    return _letterH["default"];
  }
});
Object.defineProperty(exports, "LetterI", {
  enumerable: true,
  get: function get() {
    return _letterI["default"];
  }
});
Object.defineProperty(exports, "LetterJ", {
  enumerable: true,
  get: function get() {
    return _letterJ["default"];
  }
});
Object.defineProperty(exports, "LetterK", {
  enumerable: true,
  get: function get() {
    return _letterK["default"];
  }
});
Object.defineProperty(exports, "LetterL", {
  enumerable: true,
  get: function get() {
    return _letterL["default"];
  }
});
Object.defineProperty(exports, "LetterM", {
  enumerable: true,
  get: function get() {
    return _letterM["default"];
  }
});
Object.defineProperty(exports, "LetterN", {
  enumerable: true,
  get: function get() {
    return _letterN["default"];
  }
});
Object.defineProperty(exports, "LetterO", {
  enumerable: true,
  get: function get() {
    return _letterO["default"];
  }
});
Object.defineProperty(exports, "LetterP", {
  enumerable: true,
  get: function get() {
    return _letterP["default"];
  }
});
Object.defineProperty(exports, "LetterQ", {
  enumerable: true,
  get: function get() {
    return _letterQ["default"];
  }
});
Object.defineProperty(exports, "LetterR", {
  enumerable: true,
  get: function get() {
    return _letterR["default"];
  }
});
Object.defineProperty(exports, "LetterS", {
  enumerable: true,
  get: function get() {
    return _letterS["default"];
  }
});
Object.defineProperty(exports, "LetterT", {
  enumerable: true,
  get: function get() {
    return _letterT["default"];
  }
});
Object.defineProperty(exports, "LetterU", {
  enumerable: true,
  get: function get() {
    return _letterU["default"];
  }
});
Object.defineProperty(exports, "LetterV", {
  enumerable: true,
  get: function get() {
    return _letterV["default"];
  }
});
Object.defineProperty(exports, "LetterW", {
  enumerable: true,
  get: function get() {
    return _letterW["default"];
  }
});
Object.defineProperty(exports, "LetterX", {
  enumerable: true,
  get: function get() {
    return _letterX["default"];
  }
});
Object.defineProperty(exports, "LetterY", {
  enumerable: true,
  get: function get() {
    return _letterY["default"];
  }
});
Object.defineProperty(exports, "LetterZ", {
  enumerable: true,
  get: function get() {
    return _letterZ["default"];
  }
});
Object.defineProperty(exports, "LettersCase", {
  enumerable: true,
  get: function get() {
    return _lettersCase["default"];
  }
});
Object.defineProperty(exports, "License", {
  enumerable: true,
  get: function get() {
    return _license["default"];
  }
});
Object.defineProperty(exports, "Lifebuoy", {
  enumerable: true,
  get: function get() {
    return _lifebuoy["default"];
  }
});
Object.defineProperty(exports, "LineHeight", {
  enumerable: true,
  get: function get() {
    return _lineHeight["default"];
  }
});
Object.defineProperty(exports, "Line", {
  enumerable: true,
  get: function get() {
    return _line["default"];
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _link["default"];
  }
});
Object.defineProperty(exports, "ListCheck", {
  enumerable: true,
  get: function get() {
    return _listCheck["default"];
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _list["default"];
  }
});
Object.defineProperty(exports, "LivePhoto", {
  enumerable: true,
  get: function get() {
    return _livePhoto["default"];
  }
});
Object.defineProperty(exports, "LiveView", {
  enumerable: true,
  get: function get() {
    return _liveView["default"];
  }
});
Object.defineProperty(exports, "LoaderQuarter", {
  enumerable: true,
  get: function get() {
    return _loaderQuarter["default"];
  }
});
Object.defineProperty(exports, "Loader", {
  enumerable: true,
  get: function get() {
    return _loader["default"];
  }
});
Object.defineProperty(exports, "Location", {
  enumerable: true,
  get: function get() {
    return _location["default"];
  }
});
Object.defineProperty(exports, "LockOff", {
  enumerable: true,
  get: function get() {
    return _lockOff["default"];
  }
});
Object.defineProperty(exports, "LockOpen", {
  enumerable: true,
  get: function get() {
    return _lockOpen["default"];
  }
});
Object.defineProperty(exports, "Lock", {
  enumerable: true,
  get: function get() {
    return _lock["default"];
  }
});
Object.defineProperty(exports, "Login", {
  enumerable: true,
  get: function get() {
    return _login["default"];
  }
});
Object.defineProperty(exports, "Logout", {
  enumerable: true,
  get: function get() {
    return _logout["default"];
  }
});
Object.defineProperty(exports, "Magnet", {
  enumerable: true,
  get: function get() {
    return _magnet["default"];
  }
});
Object.defineProperty(exports, "MailOpened", {
  enumerable: true,
  get: function get() {
    return _mailOpened["default"];
  }
});
Object.defineProperty(exports, "Mail", {
  enumerable: true,
  get: function get() {
    return _mail["default"];
  }
});
Object.defineProperty(exports, "Man", {
  enumerable: true,
  get: function get() {
    return _man["default"];
  }
});
Object.defineProperty(exports, "ManualGearbox", {
  enumerable: true,
  get: function get() {
    return _manualGearbox["default"];
  }
});
Object.defineProperty(exports, "Map2", {
  enumerable: true,
  get: function get() {
    return _map["default"];
  }
});
Object.defineProperty(exports, "MapPinOff", {
  enumerable: true,
  get: function get() {
    return _mapPinOff["default"];
  }
});
Object.defineProperty(exports, "MapPin", {
  enumerable: true,
  get: function get() {
    return _mapPin["default"];
  }
});
Object.defineProperty(exports, "MapPins", {
  enumerable: true,
  get: function get() {
    return _mapPins["default"];
  }
});
Object.defineProperty(exports, "Map", {
  enumerable: true,
  get: function get() {
    return _map2["default"];
  }
});
Object.defineProperty(exports, "Markdown", {
  enumerable: true,
  get: function get() {
    return _markdown["default"];
  }
});
Object.defineProperty(exports, "Marquee", {
  enumerable: true,
  get: function get() {
    return _marquee["default"];
  }
});
Object.defineProperty(exports, "Mars", {
  enumerable: true,
  get: function get() {
    return _mars["default"];
  }
});
Object.defineProperty(exports, "Math", {
  enumerable: true,
  get: function get() {
    return _math["default"];
  }
});
Object.defineProperty(exports, "Maximize", {
  enumerable: true,
  get: function get() {
    return _maximize["default"];
  }
});
Object.defineProperty(exports, "Medal", {
  enumerable: true,
  get: function get() {
    return _medal["default"];
  }
});
Object.defineProperty(exports, "MedicalCross", {
  enumerable: true,
  get: function get() {
    return _medicalCross["default"];
  }
});
Object.defineProperty(exports, "Menu2", {
  enumerable: true,
  get: function get() {
    return _menu["default"];
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function get() {
    return _menu2["default"];
  }
});
Object.defineProperty(exports, "Message2", {
  enumerable: true,
  get: function get() {
    return _message["default"];
  }
});
Object.defineProperty(exports, "MessageCircle2", {
  enumerable: true,
  get: function get() {
    return _messageCircle["default"];
  }
});
Object.defineProperty(exports, "MessageCircleOff", {
  enumerable: true,
  get: function get() {
    return _messageCircleOff["default"];
  }
});
Object.defineProperty(exports, "MessageCircle", {
  enumerable: true,
  get: function get() {
    return _messageCircle2["default"];
  }
});
Object.defineProperty(exports, "MessageDots", {
  enumerable: true,
  get: function get() {
    return _messageDots["default"];
  }
});
Object.defineProperty(exports, "MessageOff", {
  enumerable: true,
  get: function get() {
    return _messageOff["default"];
  }
});
Object.defineProperty(exports, "MessagePlus", {
  enumerable: true,
  get: function get() {
    return _messagePlus["default"];
  }
});
Object.defineProperty(exports, "MessageReport", {
  enumerable: true,
  get: function get() {
    return _messageReport["default"];
  }
});
Object.defineProperty(exports, "Message", {
  enumerable: true,
  get: function get() {
    return _message2["default"];
  }
});
Object.defineProperty(exports, "MessagesOff", {
  enumerable: true,
  get: function get() {
    return _messagesOff["default"];
  }
});
Object.defineProperty(exports, "Messages", {
  enumerable: true,
  get: function get() {
    return _messages["default"];
  }
});
Object.defineProperty(exports, "MicrophoneOff", {
  enumerable: true,
  get: function get() {
    return _microphoneOff["default"];
  }
});
Object.defineProperty(exports, "Microphone", {
  enumerable: true,
  get: function get() {
    return _microphone["default"];
  }
});
Object.defineProperty(exports, "Minimize", {
  enumerable: true,
  get: function get() {
    return _minimize["default"];
  }
});
Object.defineProperty(exports, "Minus", {
  enumerable: true,
  get: function get() {
    return _minus["default"];
  }
});
Object.defineProperty(exports, "Mist", {
  enumerable: true,
  get: function get() {
    return _mist["default"];
  }
});
Object.defineProperty(exports, "MoodBoy", {
  enumerable: true,
  get: function get() {
    return _moodBoy["default"];
  }
});
Object.defineProperty(exports, "MoodConfuzed", {
  enumerable: true,
  get: function get() {
    return _moodConfuzed["default"];
  }
});
Object.defineProperty(exports, "MoodCrazyHappy", {
  enumerable: true,
  get: function get() {
    return _moodCrazyHappy["default"];
  }
});
Object.defineProperty(exports, "MoodCry", {
  enumerable: true,
  get: function get() {
    return _moodCry["default"];
  }
});
Object.defineProperty(exports, "MoodHappy", {
  enumerable: true,
  get: function get() {
    return _moodHappy["default"];
  }
});
Object.defineProperty(exports, "MoodKid", {
  enumerable: true,
  get: function get() {
    return _moodKid["default"];
  }
});
Object.defineProperty(exports, "MoodNeutral", {
  enumerable: true,
  get: function get() {
    return _moodNeutral["default"];
  }
});
Object.defineProperty(exports, "MoodSad", {
  enumerable: true,
  get: function get() {
    return _moodSad["default"];
  }
});
Object.defineProperty(exports, "MoodSmile", {
  enumerable: true,
  get: function get() {
    return _moodSmile["default"];
  }
});
Object.defineProperty(exports, "MoodSuprised", {
  enumerable: true,
  get: function get() {
    return _moodSuprised["default"];
  }
});
Object.defineProperty(exports, "MoodTongue", {
  enumerable: true,
  get: function get() {
    return _moodTongue["default"];
  }
});
Object.defineProperty(exports, "Moon2", {
  enumerable: true,
  get: function get() {
    return _moon["default"];
  }
});
Object.defineProperty(exports, "MoonStars", {
  enumerable: true,
  get: function get() {
    return _moonStars["default"];
  }
});
Object.defineProperty(exports, "Moon", {
  enumerable: true,
  get: function get() {
    return _moon2["default"];
  }
});
Object.defineProperty(exports, "Moped", {
  enumerable: true,
  get: function get() {
    return _moped["default"];
  }
});
Object.defineProperty(exports, "Mouse", {
  enumerable: true,
  get: function get() {
    return _mouse["default"];
  }
});
Object.defineProperty(exports, "Movie", {
  enumerable: true,
  get: function get() {
    return _movie["default"];
  }
});
Object.defineProperty(exports, "Mug", {
  enumerable: true,
  get: function get() {
    return _mug["default"];
  }
});
Object.defineProperty(exports, "Music", {
  enumerable: true,
  get: function get() {
    return _music["default"];
  }
});
Object.defineProperty(exports, "NewSection", {
  enumerable: true,
  get: function get() {
    return _newSection["default"];
  }
});
Object.defineProperty(exports, "News", {
  enumerable: true,
  get: function get() {
    return _news["default"];
  }
});
Object.defineProperty(exports, "Note", {
  enumerable: true,
  get: function get() {
    return _note["default"];
  }
});
Object.defineProperty(exports, "Notebook", {
  enumerable: true,
  get: function get() {
    return _notebook["default"];
  }
});
Object.defineProperty(exports, "Notes", {
  enumerable: true,
  get: function get() {
    return _notes["default"];
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _notification["default"];
  }
});
Object.defineProperty(exports, "Octagon", {
  enumerable: true,
  get: function get() {
    return _octagon["default"];
  }
});
Object.defineProperty(exports, "Omega", {
  enumerable: true,
  get: function get() {
    return _omega["default"];
  }
});
Object.defineProperty(exports, "Outlet", {
  enumerable: true,
  get: function get() {
    return _outlet["default"];
  }
});
Object.defineProperty(exports, "Package", {
  enumerable: true,
  get: function get() {
    return _package["default"];
  }
});
Object.defineProperty(exports, "PageBreak", {
  enumerable: true,
  get: function get() {
    return _pageBreak["default"];
  }
});
Object.defineProperty(exports, "Paint", {
  enumerable: true,
  get: function get() {
    return _paint["default"];
  }
});
Object.defineProperty(exports, "Palette", {
  enumerable: true,
  get: function get() {
    return _palette["default"];
  }
});
Object.defineProperty(exports, "PanoramaHorizontal", {
  enumerable: true,
  get: function get() {
    return _panoramaHorizontal["default"];
  }
});
Object.defineProperty(exports, "PanoramaVertical", {
  enumerable: true,
  get: function get() {
    return _panoramaVertical["default"];
  }
});
Object.defineProperty(exports, "Paperclip", {
  enumerable: true,
  get: function get() {
    return _paperclip["default"];
  }
});
Object.defineProperty(exports, "Parachute", {
  enumerable: true,
  get: function get() {
    return _parachute["default"];
  }
});
Object.defineProperty(exports, "Parentheses", {
  enumerable: true,
  get: function get() {
    return _parentheses["default"];
  }
});
Object.defineProperty(exports, "Parking", {
  enumerable: true,
  get: function get() {
    return _parking["default"];
  }
});
Object.defineProperty(exports, "Peace", {
  enumerable: true,
  get: function get() {
    return _peace["default"];
  }
});
Object.defineProperty(exports, "Pencil", {
  enumerable: true,
  get: function get() {
    return _pencil["default"];
  }
});
Object.defineProperty(exports, "Pennant", {
  enumerable: true,
  get: function get() {
    return _pennant["default"];
  }
});
Object.defineProperty(exports, "Percentage", {
  enumerable: true,
  get: function get() {
    return _percentage["default"];
  }
});
Object.defineProperty(exports, "PhoneCall", {
  enumerable: true,
  get: function get() {
    return _phoneCall["default"];
  }
});
Object.defineProperty(exports, "PhoneCalling", {
  enumerable: true,
  get: function get() {
    return _phoneCalling["default"];
  }
});
Object.defineProperty(exports, "PhoneCheck", {
  enumerable: true,
  get: function get() {
    return _phoneCheck["default"];
  }
});
Object.defineProperty(exports, "PhoneIncoming", {
  enumerable: true,
  get: function get() {
    return _phoneIncoming["default"];
  }
});
Object.defineProperty(exports, "PhoneOff", {
  enumerable: true,
  get: function get() {
    return _phoneOff["default"];
  }
});
Object.defineProperty(exports, "PhoneOutgoing", {
  enumerable: true,
  get: function get() {
    return _phoneOutgoing["default"];
  }
});
Object.defineProperty(exports, "PhonePause", {
  enumerable: true,
  get: function get() {
    return _phonePause["default"];
  }
});
Object.defineProperty(exports, "PhonePlus", {
  enumerable: true,
  get: function get() {
    return _phonePlus["default"];
  }
});
Object.defineProperty(exports, "PhoneX", {
  enumerable: true,
  get: function get() {
    return _phoneX["default"];
  }
});
Object.defineProperty(exports, "Phone", {
  enumerable: true,
  get: function get() {
    return _phone["default"];
  }
});
Object.defineProperty(exports, "PhotoOff", {
  enumerable: true,
  get: function get() {
    return _photoOff["default"];
  }
});
Object.defineProperty(exports, "Photo", {
  enumerable: true,
  get: function get() {
    return _photo["default"];
  }
});
Object.defineProperty(exports, "PictureInPictureOff", {
  enumerable: true,
  get: function get() {
    return _pictureInPictureOff["default"];
  }
});
Object.defineProperty(exports, "PictureInPictureOn", {
  enumerable: true,
  get: function get() {
    return _pictureInPictureOn["default"];
  }
});
Object.defineProperty(exports, "PictureInPicture", {
  enumerable: true,
  get: function get() {
    return _pictureInPicture["default"];
  }
});
Object.defineProperty(exports, "Pill", {
  enumerable: true,
  get: function get() {
    return _pill["default"];
  }
});
Object.defineProperty(exports, "Pin", {
  enumerable: true,
  get: function get() {
    return _pin["default"];
  }
});
Object.defineProperty(exports, "PinnedOff", {
  enumerable: true,
  get: function get() {
    return _pinnedOff["default"];
  }
});
Object.defineProperty(exports, "Pinned", {
  enumerable: true,
  get: function get() {
    return _pinned["default"];
  }
});
Object.defineProperty(exports, "PlaneArrival", {
  enumerable: true,
  get: function get() {
    return _planeArrival["default"];
  }
});
Object.defineProperty(exports, "PlaneDeparture", {
  enumerable: true,
  get: function get() {
    return _planeDeparture["default"];
  }
});
Object.defineProperty(exports, "Plane", {
  enumerable: true,
  get: function get() {
    return _plane["default"];
  }
});
Object.defineProperty(exports, "Planet", {
  enumerable: true,
  get: function get() {
    return _planet["default"];
  }
});
Object.defineProperty(exports, "Plant2", {
  enumerable: true,
  get: function get() {
    return _plant["default"];
  }
});
Object.defineProperty(exports, "Plant", {
  enumerable: true,
  get: function get() {
    return _plant2["default"];
  }
});
Object.defineProperty(exports, "PlayerPause", {
  enumerable: true,
  get: function get() {
    return _playerPause["default"];
  }
});
Object.defineProperty(exports, "PlayerPlay", {
  enumerable: true,
  get: function get() {
    return _playerPlay["default"];
  }
});
Object.defineProperty(exports, "PlayerRecord", {
  enumerable: true,
  get: function get() {
    return _playerRecord["default"];
  }
});
Object.defineProperty(exports, "PlayerSkipBack", {
  enumerable: true,
  get: function get() {
    return _playerSkipBack["default"];
  }
});
Object.defineProperty(exports, "PlayerSkipForward", {
  enumerable: true,
  get: function get() {
    return _playerSkipForward["default"];
  }
});
Object.defineProperty(exports, "PlayerStop", {
  enumerable: true,
  get: function get() {
    return _playerStop["default"];
  }
});
Object.defineProperty(exports, "PlayerTrackNext", {
  enumerable: true,
  get: function get() {
    return _playerTrackNext["default"];
  }
});
Object.defineProperty(exports, "PlayerTrackPrev", {
  enumerable: true,
  get: function get() {
    return _playerTrackPrev["default"];
  }
});
Object.defineProperty(exports, "Plug", {
  enumerable: true,
  get: function get() {
    return _plug["default"];
  }
});
Object.defineProperty(exports, "Plus", {
  enumerable: true,
  get: function get() {
    return _plus["default"];
  }
});
Object.defineProperty(exports, "Point", {
  enumerable: true,
  get: function get() {
    return _point["default"];
  }
});
Object.defineProperty(exports, "Pool", {
  enumerable: true,
  get: function get() {
    return _pool["default"];
  }
});
Object.defineProperty(exports, "Power", {
  enumerable: true,
  get: function get() {
    return _power["default"];
  }
});
Object.defineProperty(exports, "Pray", {
  enumerable: true,
  get: function get() {
    return _pray["default"];
  }
});
Object.defineProperty(exports, "Presentation", {
  enumerable: true,
  get: function get() {
    return _presentation["default"];
  }
});
Object.defineProperty(exports, "Printer", {
  enumerable: true,
  get: function get() {
    return _printer["default"];
  }
});
Object.defineProperty(exports, "Prompt", {
  enumerable: true,
  get: function get() {
    return _prompt["default"];
  }
});
Object.defineProperty(exports, "Puzzle", {
  enumerable: true,
  get: function get() {
    return _puzzle["default"];
  }
});
Object.defineProperty(exports, "Qrcode", {
  enumerable: true,
  get: function get() {
    return _qrcode["default"];
  }
});
Object.defineProperty(exports, "QuestionMark", {
  enumerable: true,
  get: function get() {
    return _questionMark["default"];
  }
});
Object.defineProperty(exports, "Radioactive", {
  enumerable: true,
  get: function get() {
    return _radioactive["default"];
  }
});
Object.defineProperty(exports, "RecordMail", {
  enumerable: true,
  get: function get() {
    return _recordMail["default"];
  }
});
Object.defineProperty(exports, "RectangleVertical", {
  enumerable: true,
  get: function get() {
    return _rectangleVertical["default"];
  }
});
Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _rectangle["default"];
  }
});
Object.defineProperty(exports, "Recycle", {
  enumerable: true,
  get: function get() {
    return _recycle["default"];
  }
});
Object.defineProperty(exports, "RefreshAlert", {
  enumerable: true,
  get: function get() {
    return _refreshAlert["default"];
  }
});
Object.defineProperty(exports, "Refresh", {
  enumerable: true,
  get: function get() {
    return _refresh["default"];
  }
});
Object.defineProperty(exports, "Registered", {
  enumerable: true,
  get: function get() {
    return _registered["default"];
  }
});
Object.defineProperty(exports, "RelationManyToMany", {
  enumerable: true,
  get: function get() {
    return _relationManyToMany["default"];
  }
});
Object.defineProperty(exports, "RelationOneToMany", {
  enumerable: true,
  get: function get() {
    return _relationOneToMany["default"];
  }
});
Object.defineProperty(exports, "RelationOneToOne", {
  enumerable: true,
  get: function get() {
    return _relationOneToOne["default"];
  }
});
Object.defineProperty(exports, "RepeatOnce", {
  enumerable: true,
  get: function get() {
    return _repeatOnce["default"];
  }
});
Object.defineProperty(exports, "Repeat", {
  enumerable: true,
  get: function get() {
    return _repeat["default"];
  }
});
Object.defineProperty(exports, "Replace", {
  enumerable: true,
  get: function get() {
    return _replace["default"];
  }
});
Object.defineProperty(exports, "Ripple", {
  enumerable: true,
  get: function get() {
    return _ripple["default"];
  }
});
Object.defineProperty(exports, "RoadSign", {
  enumerable: true,
  get: function get() {
    return _roadSign["default"];
  }
});
Object.defineProperty(exports, "Rocket", {
  enumerable: true,
  get: function get() {
    return _rocket["default"];
  }
});
Object.defineProperty(exports, "Rotate2", {
  enumerable: true,
  get: function get() {
    return _rotate["default"];
  }
});
Object.defineProperty(exports, "RotateClockwise2", {
  enumerable: true,
  get: function get() {
    return _rotateClockwise["default"];
  }
});
Object.defineProperty(exports, "RotateClockwise", {
  enumerable: true,
  get: function get() {
    return _rotateClockwise2["default"];
  }
});
Object.defineProperty(exports, "RotateRectangle", {
  enumerable: true,
  get: function get() {
    return _rotateRectangle["default"];
  }
});
Object.defineProperty(exports, "Rotate", {
  enumerable: true,
  get: function get() {
    return _rotate2["default"];
  }
});
Object.defineProperty(exports, "Route", {
  enumerable: true,
  get: function get() {
    return _route["default"];
  }
});
Object.defineProperty(exports, "Router", {
  enumerable: true,
  get: function get() {
    return _router["default"];
  }
});
Object.defineProperty(exports, "Rss", {
  enumerable: true,
  get: function get() {
    return _rss["default"];
  }
});
Object.defineProperty(exports, "Ruler", {
  enumerable: true,
  get: function get() {
    return _ruler["default"];
  }
});
Object.defineProperty(exports, "Run", {
  enumerable: true,
  get: function get() {
    return _run["default"];
  }
});
Object.defineProperty(exports, "Sailboat", {
  enumerable: true,
  get: function get() {
    return _sailboat["default"];
  }
});
Object.defineProperty(exports, "Scale", {
  enumerable: true,
  get: function get() {
    return _scale["default"];
  }
});
Object.defineProperty(exports, "Scan", {
  enumerable: true,
  get: function get() {
    return _scan["default"];
  }
});
Object.defineProperty(exports, "School", {
  enumerable: true,
  get: function get() {
    return _school["default"];
  }
});
Object.defineProperty(exports, "Scissors", {
  enumerable: true,
  get: function get() {
    return _scissors["default"];
  }
});
Object.defineProperty(exports, "ScooterElectric", {
  enumerable: true,
  get: function get() {
    return _scooterElectric["default"];
  }
});
Object.defineProperty(exports, "Scooter", {
  enumerable: true,
  get: function get() {
    return _scooter["default"];
  }
});
Object.defineProperty(exports, "ScreenShareOff", {
  enumerable: true,
  get: function get() {
    return _screenShareOff["default"];
  }
});
Object.defineProperty(exports, "ScreenShare", {
  enumerable: true,
  get: function get() {
    return _screenShare["default"];
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _search["default"];
  }
});
Object.defineProperty(exports, "Seeding", {
  enumerable: true,
  get: function get() {
    return _seeding["default"];
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function get() {
    return _select["default"];
  }
});
Object.defineProperty(exports, "Selector", {
  enumerable: true,
  get: function get() {
    return _selector["default"];
  }
});
Object.defineProperty(exports, "Send", {
  enumerable: true,
  get: function get() {
    return _send["default"];
  }
});
Object.defineProperty(exports, "SeparatorHorizontal", {
  enumerable: true,
  get: function get() {
    return _separatorHorizontal["default"];
  }
});
Object.defineProperty(exports, "SeparatorVertical", {
  enumerable: true,
  get: function get() {
    return _separatorVertical["default"];
  }
});
Object.defineProperty(exports, "Separator", {
  enumerable: true,
  get: function get() {
    return _separator["default"];
  }
});
Object.defineProperty(exports, "Server", {
  enumerable: true,
  get: function get() {
    return _server["default"];
  }
});
Object.defineProperty(exports, "Servicemark", {
  enumerable: true,
  get: function get() {
    return _servicemark["default"];
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function get() {
    return _settings["default"];
  }
});
Object.defineProperty(exports, "Shape", {
  enumerable: true,
  get: function get() {
    return _shape["default"];
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function get() {
    return _share["default"];
  }
});
Object.defineProperty(exports, "ShieldCheck", {
  enumerable: true,
  get: function get() {
    return _shieldCheck["default"];
  }
});
Object.defineProperty(exports, "ShieldLock", {
  enumerable: true,
  get: function get() {
    return _shieldLock["default"];
  }
});
Object.defineProperty(exports, "ShieldOff", {
  enumerable: true,
  get: function get() {
    return _shieldOff["default"];
  }
});
Object.defineProperty(exports, "ShieldX", {
  enumerable: true,
  get: function get() {
    return _shieldX["default"];
  }
});
Object.defineProperty(exports, "Shield", {
  enumerable: true,
  get: function get() {
    return _shield["default"];
  }
});
Object.defineProperty(exports, "Ship", {
  enumerable: true,
  get: function get() {
    return _ship["default"];
  }
});
Object.defineProperty(exports, "Shirt", {
  enumerable: true,
  get: function get() {
    return _shirt["default"];
  }
});
Object.defineProperty(exports, "ShoppingCart", {
  enumerable: true,
  get: function get() {
    return _shoppingCart["default"];
  }
});
Object.defineProperty(exports, "Sitemap", {
  enumerable: true,
  get: function get() {
    return _sitemap["default"];
  }
});
Object.defineProperty(exports, "Skateboard", {
  enumerable: true,
  get: function get() {
    return _skateboard["default"];
  }
});
Object.defineProperty(exports, "Slice", {
  enumerable: true,
  get: function get() {
    return _slice["default"];
  }
});
Object.defineProperty(exports, "Slideshow", {
  enumerable: true,
  get: function get() {
    return _slideshow["default"];
  }
});
Object.defineProperty(exports, "SmartHome", {
  enumerable: true,
  get: function get() {
    return _smartHome["default"];
  }
});
Object.defineProperty(exports, "SmokingNo", {
  enumerable: true,
  get: function get() {
    return _smokingNo["default"];
  }
});
Object.defineProperty(exports, "Smoking", {
  enumerable: true,
  get: function get() {
    return _smoking["default"];
  }
});
Object.defineProperty(exports, "Snowflake", {
  enumerable: true,
  get: function get() {
    return _snowflake["default"];
  }
});
Object.defineProperty(exports, "SoccerField", {
  enumerable: true,
  get: function get() {
    return _soccerField["default"];
  }
});
Object.defineProperty(exports, "Social", {
  enumerable: true,
  get: function get() {
    return _social["default"];
  }
});
Object.defineProperty(exports, "SortAscending", {
  enumerable: true,
  get: function get() {
    return _sortAscending["default"];
  }
});
Object.defineProperty(exports, "SortDescending", {
  enumerable: true,
  get: function get() {
    return _sortDescending["default"];
  }
});
Object.defineProperty(exports, "Space", {
  enumerable: true,
  get: function get() {
    return _space["default"];
  }
});
Object.defineProperty(exports, "Speakerphone", {
  enumerable: true,
  get: function get() {
    return _speakerphone["default"];
  }
});
Object.defineProperty(exports, "Speedboat", {
  enumerable: true,
  get: function get() {
    return _speedboat["default"];
  }
});
Object.defineProperty(exports, "SquareCheck", {
  enumerable: true,
  get: function get() {
    return _squareCheck["default"];
  }
});
Object.defineProperty(exports, "SquareDot", {
  enumerable: true,
  get: function get() {
    return _squareDot["default"];
  }
});
Object.defineProperty(exports, "SquareForbid2", {
  enumerable: true,
  get: function get() {
    return _squareForbid["default"];
  }
});
Object.defineProperty(exports, "SquareForbid", {
  enumerable: true,
  get: function get() {
    return _squareForbid2["default"];
  }
});
Object.defineProperty(exports, "SquareMinus", {
  enumerable: true,
  get: function get() {
    return _squareMinus["default"];
  }
});
Object.defineProperty(exports, "SquarePlus", {
  enumerable: true,
  get: function get() {
    return _squarePlus["default"];
  }
});
Object.defineProperty(exports, "SquareRotated", {
  enumerable: true,
  get: function get() {
    return _squareRotated["default"];
  }
});
Object.defineProperty(exports, "SquareX", {
  enumerable: true,
  get: function get() {
    return _squareX["default"];
  }
});
Object.defineProperty(exports, "Square", {
  enumerable: true,
  get: function get() {
    return _square["default"];
  }
});
Object.defineProperty(exports, "Stack", {
  enumerable: true,
  get: function get() {
    return _stack["default"];
  }
});
Object.defineProperty(exports, "StairsDown", {
  enumerable: true,
  get: function get() {
    return _stairsDown["default"];
  }
});
Object.defineProperty(exports, "StairsUp", {
  enumerable: true,
  get: function get() {
    return _stairsUp["default"];
  }
});
Object.defineProperty(exports, "Stairs", {
  enumerable: true,
  get: function get() {
    return _stairs["default"];
  }
});
Object.defineProperty(exports, "StarHalf", {
  enumerable: true,
  get: function get() {
    return _starHalf["default"];
  }
});
Object.defineProperty(exports, "StarOff", {
  enumerable: true,
  get: function get() {
    return _starOff["default"];
  }
});
Object.defineProperty(exports, "Star", {
  enumerable: true,
  get: function get() {
    return _star["default"];
  }
});
Object.defineProperty(exports, "Stars", {
  enumerable: true,
  get: function get() {
    return _stars["default"];
  }
});
Object.defineProperty(exports, "SteeringWheel", {
  enumerable: true,
  get: function get() {
    return _steeringWheel["default"];
  }
});
Object.defineProperty(exports, "StepInto", {
  enumerable: true,
  get: function get() {
    return _stepInto["default"];
  }
});
Object.defineProperty(exports, "StepOut", {
  enumerable: true,
  get: function get() {
    return _stepOut["default"];
  }
});
Object.defineProperty(exports, "Sthetoscope", {
  enumerable: true,
  get: function get() {
    return _sthetoscope["default"];
  }
});
Object.defineProperty(exports, "Sticker", {
  enumerable: true,
  get: function get() {
    return _sticker["default"];
  }
});
Object.defineProperty(exports, "Strikethrough", {
  enumerable: true,
  get: function get() {
    return _strikethrough["default"];
  }
});
Object.defineProperty(exports, "Submarine", {
  enumerable: true,
  get: function get() {
    return _submarine["default"];
  }
});
Object.defineProperty(exports, "Subscript", {
  enumerable: true,
  get: function get() {
    return _subscript["default"];
  }
});
Object.defineProperty(exports, "Subtask", {
  enumerable: true,
  get: function get() {
    return _subtask["default"];
  }
});
Object.defineProperty(exports, "Sum", {
  enumerable: true,
  get: function get() {
    return _sum["default"];
  }
});
Object.defineProperty(exports, "SunOff", {
  enumerable: true,
  get: function get() {
    return _sunOff["default"];
  }
});
Object.defineProperty(exports, "Sun", {
  enumerable: true,
  get: function get() {
    return _sun["default"];
  }
});
Object.defineProperty(exports, "Sunset", {
  enumerable: true,
  get: function get() {
    return _sunset["default"];
  }
});
Object.defineProperty(exports, "Sunshine", {
  enumerable: true,
  get: function get() {
    return _sunshine["default"];
  }
});
Object.defineProperty(exports, "Superscript", {
  enumerable: true,
  get: function get() {
    return _superscript["default"];
  }
});
Object.defineProperty(exports, "Swimming", {
  enumerable: true,
  get: function get() {
    return _swimming["default"];
  }
});
Object.defineProperty(exports, "SwitchHorizontal", {
  enumerable: true,
  get: function get() {
    return _switchHorizontal["default"];
  }
});
Object.defineProperty(exports, "SwitchVertical", {
  enumerable: true,
  get: function get() {
    return _switchVertical["default"];
  }
});
Object.defineProperty(exports, "Switch", {
  enumerable: true,
  get: function get() {
    return _switch["default"];
  }
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return _table["default"];
  }
});
Object.defineProperty(exports, "Tag", {
  enumerable: true,
  get: function get() {
    return _tag["default"];
  }
});
Object.defineProperty(exports, "Tallymark1", {
  enumerable: true,
  get: function get() {
    return _tallymark["default"];
  }
});
Object.defineProperty(exports, "Tallymark2", {
  enumerable: true,
  get: function get() {
    return _tallymark2["default"];
  }
});
Object.defineProperty(exports, "Tallymark3", {
  enumerable: true,
  get: function get() {
    return _tallymark3["default"];
  }
});
Object.defineProperty(exports, "Tallymark4", {
  enumerable: true,
  get: function get() {
    return _tallymark4["default"];
  }
});
Object.defineProperty(exports, "Tallymarks", {
  enumerable: true,
  get: function get() {
    return _tallymarks["default"];
  }
});
Object.defineProperty(exports, "Tank", {
  enumerable: true,
  get: function get() {
    return _tank["default"];
  }
});
Object.defineProperty(exports, "Target", {
  enumerable: true,
  get: function get() {
    return _target["default"];
  }
});
Object.defineProperty(exports, "Tax", {
  enumerable: true,
  get: function get() {
    return _tax["default"];
  }
});
Object.defineProperty(exports, "TemperatureCelsius", {
  enumerable: true,
  get: function get() {
    return _temperatureCelsius["default"];
  }
});
Object.defineProperty(exports, "TemperatureFahrenheit", {
  enumerable: true,
  get: function get() {
    return _temperatureFahrenheit["default"];
  }
});
Object.defineProperty(exports, "TemperatureMinus", {
  enumerable: true,
  get: function get() {
    return _temperatureMinus["default"];
  }
});
Object.defineProperty(exports, "TemperaturePlus", {
  enumerable: true,
  get: function get() {
    return _temperaturePlus["default"];
  }
});
Object.defineProperty(exports, "Temperature", {
  enumerable: true,
  get: function get() {
    return _temperature["default"];
  }
});
Object.defineProperty(exports, "Template", {
  enumerable: true,
  get: function get() {
    return _template["default"];
  }
});
Object.defineProperty(exports, "Terminal2", {
  enumerable: true,
  get: function get() {
    return _terminal["default"];
  }
});
Object.defineProperty(exports, "Terminal", {
  enumerable: true,
  get: function get() {
    return _terminal2["default"];
  }
});
Object.defineProperty(exports, "TestPipe", {
  enumerable: true,
  get: function get() {
    return _testPipe["default"];
  }
});
Object.defineProperty(exports, "TextWrapDisabled", {
  enumerable: true,
  get: function get() {
    return _textWrapDisabled["default"];
  }
});
Object.defineProperty(exports, "TextWrap", {
  enumerable: true,
  get: function get() {
    return _textWrap["default"];
  }
});
Object.defineProperty(exports, "ThumbDown", {
  enumerable: true,
  get: function get() {
    return _thumbDown["default"];
  }
});
Object.defineProperty(exports, "ThumbUp", {
  enumerable: true,
  get: function get() {
    return _thumbUp["default"];
  }
});
Object.defineProperty(exports, "Ticket", {
  enumerable: true,
  get: function get() {
    return _ticket["default"];
  }
});
Object.defineProperty(exports, "Tir", {
  enumerable: true,
  get: function get() {
    return _tir["default"];
  }
});
Object.defineProperty(exports, "ToggleLeft", {
  enumerable: true,
  get: function get() {
    return _toggleLeft["default"];
  }
});
Object.defineProperty(exports, "ToggleRight", {
  enumerable: true,
  get: function get() {
    return _toggleRight["default"];
  }
});
Object.defineProperty(exports, "Tool", {
  enumerable: true,
  get: function get() {
    return _tool["default"];
  }
});
Object.defineProperty(exports, "ToolsKitchen", {
  enumerable: true,
  get: function get() {
    return _toolsKitchen["default"];
  }
});
Object.defineProperty(exports, "Tools", {
  enumerable: true,
  get: function get() {
    return _tools["default"];
  }
});
Object.defineProperty(exports, "Tornado", {
  enumerable: true,
  get: function get() {
    return _tornado["default"];
  }
});
Object.defineProperty(exports, "Tournament", {
  enumerable: true,
  get: function get() {
    return _tournament["default"];
  }
});
Object.defineProperty(exports, "Tractor", {
  enumerable: true,
  get: function get() {
    return _tractor["default"];
  }
});
Object.defineProperty(exports, "Trademark", {
  enumerable: true,
  get: function get() {
    return _trademark["default"];
  }
});
Object.defineProperty(exports, "TrafficCone", {
  enumerable: true,
  get: function get() {
    return _trafficCone["default"];
  }
});
Object.defineProperty(exports, "TrafficLights", {
  enumerable: true,
  get: function get() {
    return _trafficLights["default"];
  }
});
Object.defineProperty(exports, "Train", {
  enumerable: true,
  get: function get() {
    return _train["default"];
  }
});
Object.defineProperty(exports, "TrashOff", {
  enumerable: true,
  get: function get() {
    return _trashOff["default"];
  }
});
Object.defineProperty(exports, "Trash", {
  enumerable: true,
  get: function get() {
    return _trash["default"];
  }
});
Object.defineProperty(exports, "Trees", {
  enumerable: true,
  get: function get() {
    return _trees["default"];
  }
});
Object.defineProperty(exports, "TrendingDown", {
  enumerable: true,
  get: function get() {
    return _trendingDown["default"];
  }
});
Object.defineProperty(exports, "TrendingUp", {
  enumerable: true,
  get: function get() {
    return _trendingUp["default"];
  }
});
Object.defineProperty(exports, "TriangleSquareCircle", {
  enumerable: true,
  get: function get() {
    return _triangleSquareCircle["default"];
  }
});
Object.defineProperty(exports, "Triangle", {
  enumerable: true,
  get: function get() {
    return _triangle["default"];
  }
});
Object.defineProperty(exports, "Trident", {
  enumerable: true,
  get: function get() {
    return _trident["default"];
  }
});
Object.defineProperty(exports, "Trophy", {
  enumerable: true,
  get: function get() {
    return _trophy["default"];
  }
});
Object.defineProperty(exports, "TruckDelivery", {
  enumerable: true,
  get: function get() {
    return _truckDelivery["default"];
  }
});
Object.defineProperty(exports, "TruckReturn", {
  enumerable: true,
  get: function get() {
    return _truckReturn["default"];
  }
});
Object.defineProperty(exports, "Truck", {
  enumerable: true,
  get: function get() {
    return _truck["default"];
  }
});
Object.defineProperty(exports, "Typography", {
  enumerable: true,
  get: function get() {
    return _typography["default"];
  }
});
Object.defineProperty(exports, "Umbrella", {
  enumerable: true,
  get: function get() {
    return _umbrella["default"];
  }
});
Object.defineProperty(exports, "Underline", {
  enumerable: true,
  get: function get() {
    return _underline["default"];
  }
});
Object.defineProperty(exports, "Unlink", {
  enumerable: true,
  get: function get() {
    return _unlink["default"];
  }
});
Object.defineProperty(exports, "Upload", {
  enumerable: true,
  get: function get() {
    return _upload["default"];
  }
});
Object.defineProperty(exports, "Urgent", {
  enumerable: true,
  get: function get() {
    return _urgent["default"];
  }
});
Object.defineProperty(exports, "UserCheck", {
  enumerable: true,
  get: function get() {
    return _userCheck["default"];
  }
});
Object.defineProperty(exports, "UserExclamation", {
  enumerable: true,
  get: function get() {
    return _userExclamation["default"];
  }
});
Object.defineProperty(exports, "UserMinus", {
  enumerable: true,
  get: function get() {
    return _userMinus["default"];
  }
});
Object.defineProperty(exports, "UserOff", {
  enumerable: true,
  get: function get() {
    return _userOff["default"];
  }
});
Object.defineProperty(exports, "UserPlus", {
  enumerable: true,
  get: function get() {
    return _userPlus["default"];
  }
});
Object.defineProperty(exports, "UserX", {
  enumerable: true,
  get: function get() {
    return _userX["default"];
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _user["default"];
  }
});
Object.defineProperty(exports, "Users", {
  enumerable: true,
  get: function get() {
    return _users["default"];
  }
});
Object.defineProperty(exports, "VectorBeizer2", {
  enumerable: true,
  get: function get() {
    return _vectorBeizer["default"];
  }
});
Object.defineProperty(exports, "VectorBeizer", {
  enumerable: true,
  get: function get() {
    return _vectorBeizer2["default"];
  }
});
Object.defineProperty(exports, "VectorTriangle", {
  enumerable: true,
  get: function get() {
    return _vectorTriangle["default"];
  }
});
Object.defineProperty(exports, "Vector", {
  enumerable: true,
  get: function get() {
    return _vector["default"];
  }
});
Object.defineProperty(exports, "Venus", {
  enumerable: true,
  get: function get() {
    return _venus["default"];
  }
});
Object.defineProperty(exports, "Versions", {
  enumerable: true,
  get: function get() {
    return _versions["default"];
  }
});
Object.defineProperty(exports, "VideoMinus", {
  enumerable: true,
  get: function get() {
    return _videoMinus["default"];
  }
});
Object.defineProperty(exports, "VideoOff", {
  enumerable: true,
  get: function get() {
    return _videoOff["default"];
  }
});
Object.defineProperty(exports, "VideoPlus", {
  enumerable: true,
  get: function get() {
    return _videoPlus["default"];
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _video["default"];
  }
});
Object.defineProperty(exports, "View360", {
  enumerable: true,
  get: function get() {
    return _view["default"];
  }
});
Object.defineProperty(exports, "Viewfinder", {
  enumerable: true,
  get: function get() {
    return _viewfinder["default"];
  }
});
Object.defineProperty(exports, "ViewportNarrow", {
  enumerable: true,
  get: function get() {
    return _viewportNarrow["default"];
  }
});
Object.defineProperty(exports, "ViewportWide", {
  enumerable: true,
  get: function get() {
    return _viewportWide["default"];
  }
});
Object.defineProperty(exports, "VirusOff", {
  enumerable: true,
  get: function get() {
    return _virusOff["default"];
  }
});
Object.defineProperty(exports, "VirusSearch", {
  enumerable: true,
  get: function get() {
    return _virusSearch["default"];
  }
});
Object.defineProperty(exports, "Virus", {
  enumerable: true,
  get: function get() {
    return _virus["default"];
  }
});
Object.defineProperty(exports, "Volume2", {
  enumerable: true,
  get: function get() {
    return _volume["default"];
  }
});
Object.defineProperty(exports, "Volume3", {
  enumerable: true,
  get: function get() {
    return _volume2["default"];
  }
});
Object.defineProperty(exports, "Volume", {
  enumerable: true,
  get: function get() {
    return _volume3["default"];
  }
});
Object.defineProperty(exports, "Walk", {
  enumerable: true,
  get: function get() {
    return _walk["default"];
  }
});
Object.defineProperty(exports, "Wallet", {
  enumerable: true,
  get: function get() {
    return _wallet["default"];
  }
});
Object.defineProperty(exports, "Wand", {
  enumerable: true,
  get: function get() {
    return _wand["default"];
  }
});
Object.defineProperty(exports, "WaveSawTool", {
  enumerable: true,
  get: function get() {
    return _waveSawTool["default"];
  }
});
Object.defineProperty(exports, "WaveSine", {
  enumerable: true,
  get: function get() {
    return _waveSine["default"];
  }
});
Object.defineProperty(exports, "WaveSquare", {
  enumerable: true,
  get: function get() {
    return _waveSquare["default"];
  }
});
Object.defineProperty(exports, "Wifi0", {
  enumerable: true,
  get: function get() {
    return _wifi["default"];
  }
});
Object.defineProperty(exports, "Wifi1", {
  enumerable: true,
  get: function get() {
    return _wifi2["default"];
  }
});
Object.defineProperty(exports, "Wifi2", {
  enumerable: true,
  get: function get() {
    return _wifi3["default"];
  }
});
Object.defineProperty(exports, "WifiOff", {
  enumerable: true,
  get: function get() {
    return _wifiOff["default"];
  }
});
Object.defineProperty(exports, "Wifi", {
  enumerable: true,
  get: function get() {
    return _wifi4["default"];
  }
});
Object.defineProperty(exports, "Wind", {
  enumerable: true,
  get: function get() {
    return _wind["default"];
  }
});
Object.defineProperty(exports, "Windmill", {
  enumerable: true,
  get: function get() {
    return _windmill["default"];
  }
});
Object.defineProperty(exports, "WiperWash", {
  enumerable: true,
  get: function get() {
    return _wiperWash["default"];
  }
});
Object.defineProperty(exports, "Wiper", {
  enumerable: true,
  get: function get() {
    return _wiper["default"];
  }
});
Object.defineProperty(exports, "Woman", {
  enumerable: true,
  get: function get() {
    return _woman["default"];
  }
});
Object.defineProperty(exports, "WorldLatitude", {
  enumerable: true,
  get: function get() {
    return _worldLatitude["default"];
  }
});
Object.defineProperty(exports, "WorldLongitude", {
  enumerable: true,
  get: function get() {
    return _worldLongitude["default"];
  }
});
Object.defineProperty(exports, "World", {
  enumerable: true,
  get: function get() {
    return _world["default"];
  }
});
Object.defineProperty(exports, "WreckingBall", {
  enumerable: true,
  get: function get() {
    return _wreckingBall["default"];
  }
});
Object.defineProperty(exports, "X", {
  enumerable: true,
  get: function get() {
    return _x["default"];
  }
});
Object.defineProperty(exports, "YinYang", {
  enumerable: true,
  get: function get() {
    return _yinYang["default"];
  }
});
Object.defineProperty(exports, "ZodiacAquarius", {
  enumerable: true,
  get: function get() {
    return _zodiacAquarius["default"];
  }
});
Object.defineProperty(exports, "ZodiacAries", {
  enumerable: true,
  get: function get() {
    return _zodiacAries["default"];
  }
});
Object.defineProperty(exports, "ZodiacCancer", {
  enumerable: true,
  get: function get() {
    return _zodiacCancer["default"];
  }
});
Object.defineProperty(exports, "ZodiacCapricorn", {
  enumerable: true,
  get: function get() {
    return _zodiacCapricorn["default"];
  }
});
Object.defineProperty(exports, "ZodiacGemini", {
  enumerable: true,
  get: function get() {
    return _zodiacGemini["default"];
  }
});
Object.defineProperty(exports, "ZodiacLeo", {
  enumerable: true,
  get: function get() {
    return _zodiacLeo["default"];
  }
});
Object.defineProperty(exports, "ZodiacLibra", {
  enumerable: true,
  get: function get() {
    return _zodiacLibra["default"];
  }
});
Object.defineProperty(exports, "ZodiacPisces", {
  enumerable: true,
  get: function get() {
    return _zodiacPisces["default"];
  }
});
Object.defineProperty(exports, "ZodiacSagittarius", {
  enumerable: true,
  get: function get() {
    return _zodiacSagittarius["default"];
  }
});
Object.defineProperty(exports, "ZodiacScorpio", {
  enumerable: true,
  get: function get() {
    return _zodiacScorpio["default"];
  }
});
Object.defineProperty(exports, "ZodiacTaurus", {
  enumerable: true,
  get: function get() {
    return _zodiacTaurus["default"];
  }
});
Object.defineProperty(exports, "ZodiacVirgo", {
  enumerable: true,
  get: function get() {
    return _zodiacVirgo["default"];
  }
});
Object.defineProperty(exports, "ZoomCancel", {
  enumerable: true,
  get: function get() {
    return _zoomCancel["default"];
  }
});
Object.defineProperty(exports, "ZoomIn", {
  enumerable: true,
  get: function get() {
    return _zoomIn["default"];
  }
});
Object.defineProperty(exports, "ZoomOut", {
  enumerable: true,
  get: function get() {
    return _zoomOut["default"];
  }
});

var _fa = _interopRequireDefault(require("./icons/2fa.js"));

var _dCubeSphere = _interopRequireDefault(require("./icons/3d-cube-sphere.js"));

var _aB = _interopRequireDefault(require("./icons/a-b.js"));

var _accessPointOff = _interopRequireDefault(require("./icons/access-point-off.js"));

var _accessPoint = _interopRequireDefault(require("./icons/access-point.js"));

var _accessible = _interopRequireDefault(require("./icons/accessible.js"));

var _activity = _interopRequireDefault(require("./icons/activity.js"));

var _ad = _interopRequireDefault(require("./icons/ad.js"));

var _adjustmentsAlt = _interopRequireDefault(require("./icons/adjustments-alt.js"));

var _adjustmentsHorizontal = _interopRequireDefault(require("./icons/adjustments-horizontal.js"));

var _adjustments = _interopRequireDefault(require("./icons/adjustments.js"));

var _alarm = _interopRequireDefault(require("./icons/alarm.js"));

var _alertCircle = _interopRequireDefault(require("./icons/alert-circle.js"));

var _alertOctagon = _interopRequireDefault(require("./icons/alert-octagon.js"));

var _alertTriangle = _interopRequireDefault(require("./icons/alert-triangle.js"));

var _alien = _interopRequireDefault(require("./icons/alien.js"));

var _alignCenter = _interopRequireDefault(require("./icons/align-center.js"));

var _alignJustified = _interopRequireDefault(require("./icons/align-justified.js"));

var _alignLeft = _interopRequireDefault(require("./icons/align-left.js"));

var _alignRight = _interopRequireDefault(require("./icons/align-right.js"));

var _ambulance = _interopRequireDefault(require("./icons/ambulance.js"));

var _anchor = _interopRequireDefault(require("./icons/anchor.js"));

var _antennaBars = _interopRequireDefault(require("./icons/antenna-bars-1.js"));

var _antennaBars2 = _interopRequireDefault(require("./icons/antenna-bars-2.js"));

var _antennaBars3 = _interopRequireDefault(require("./icons/antenna-bars-3.js"));

var _antennaBars4 = _interopRequireDefault(require("./icons/antenna-bars-4.js"));

var _antennaBars5 = _interopRequireDefault(require("./icons/antenna-bars-5.js"));

var _aperture = _interopRequireDefault(require("./icons/aperture.js"));

var _apps = _interopRequireDefault(require("./icons/apps.js"));

var _archive = _interopRequireDefault(require("./icons/archive.js"));

var _arrowBackUp = _interopRequireDefault(require("./icons/arrow-back-up.js"));

var _arrowBack = _interopRequireDefault(require("./icons/arrow-back.js"));

var _arrowBarDown = _interopRequireDefault(require("./icons/arrow-bar-down.js"));

var _arrowBarLeft = _interopRequireDefault(require("./icons/arrow-bar-left.js"));

var _arrowBarRight = _interopRequireDefault(require("./icons/arrow-bar-right.js"));

var _arrowBarToDown = _interopRequireDefault(require("./icons/arrow-bar-to-down.js"));

var _arrowBarToLeft = _interopRequireDefault(require("./icons/arrow-bar-to-left.js"));

var _arrowBarToRight = _interopRequireDefault(require("./icons/arrow-bar-to-right.js"));

var _arrowBarToUp = _interopRequireDefault(require("./icons/arrow-bar-to-up.js"));

var _arrowBarUp = _interopRequireDefault(require("./icons/arrow-bar-up.js"));

var _arrowDownCircle = _interopRequireDefault(require("./icons/arrow-down-circle.js"));

var _arrowDownLeftCircle = _interopRequireDefault(require("./icons/arrow-down-left-circle.js"));

var _arrowDownLeft = _interopRequireDefault(require("./icons/arrow-down-left.js"));

var _arrowDownRightCircle = _interopRequireDefault(require("./icons/arrow-down-right-circle.js"));

var _arrowDownRight = _interopRequireDefault(require("./icons/arrow-down-right.js"));

var _arrowDown = _interopRequireDefault(require("./icons/arrow-down.js"));

var _arrowForwardUp = _interopRequireDefault(require("./icons/arrow-forward-up.js"));

var _arrowForward = _interopRequireDefault(require("./icons/arrow-forward.js"));

var _arrowLeftCircle = _interopRequireDefault(require("./icons/arrow-left-circle.js"));

var _arrowLeft = _interopRequireDefault(require("./icons/arrow-left.js"));

var _arrowNarrowDown = _interopRequireDefault(require("./icons/arrow-narrow-down.js"));

var _arrowNarrowLeft = _interopRequireDefault(require("./icons/arrow-narrow-left.js"));

var _arrowNarrowRight = _interopRequireDefault(require("./icons/arrow-narrow-right.js"));

var _arrowNarrowUp = _interopRequireDefault(require("./icons/arrow-narrow-up.js"));

var _arrowRampLeft = _interopRequireDefault(require("./icons/arrow-ramp-left.js"));

var _arrowRampRight = _interopRequireDefault(require("./icons/arrow-ramp-right.js"));

var _arrowRightCircle = _interopRequireDefault(require("./icons/arrow-right-circle.js"));

var _arrowRight = _interopRequireDefault(require("./icons/arrow-right.js"));

var _arrowUpCircle = _interopRequireDefault(require("./icons/arrow-up-circle.js"));

var _arrowUpLeftCircle = _interopRequireDefault(require("./icons/arrow-up-left-circle.js"));

var _arrowUpLeft = _interopRequireDefault(require("./icons/arrow-up-left.js"));

var _arrowUpRightCircle = _interopRequireDefault(require("./icons/arrow-up-right-circle.js"));

var _arrowUpRight = _interopRequireDefault(require("./icons/arrow-up-right.js"));

var _arrowUp = _interopRequireDefault(require("./icons/arrow-up.js"));

var _arrowsDiagonal = _interopRequireDefault(require("./icons/arrows-diagonal-2.js"));

var _arrowsDiagonal2 = _interopRequireDefault(require("./icons/arrows-diagonal.js"));

var _arrowsHorizontal = _interopRequireDefault(require("./icons/arrows-horizontal.js"));

var _arrowsMaximize = _interopRequireDefault(require("./icons/arrows-maximize.js"));

var _arrowsMinimize = _interopRequireDefault(require("./icons/arrows-minimize.js"));

var _arrowsSort = _interopRequireDefault(require("./icons/arrows-sort.js"));

var _arrowsVertical = _interopRequireDefault(require("./icons/arrows-vertical.js"));

var _artboard = _interopRequireDefault(require("./icons/artboard.js"));

var _aspectRatio = _interopRequireDefault(require("./icons/aspect-ratio.js"));

var _at = _interopRequireDefault(require("./icons/at.js"));

var _atom = _interopRequireDefault(require("./icons/atom-2.js"));

var _atom2 = _interopRequireDefault(require("./icons/atom.js"));

var _award = _interopRequireDefault(require("./icons/award.js"));

var _backhoe = _interopRequireDefault(require("./icons/backhoe.js"));

var _backspace = _interopRequireDefault(require("./icons/backspace.js"));

var _ballBasketball = _interopRequireDefault(require("./icons/ball-basketball.js"));

var _ballBowling = _interopRequireDefault(require("./icons/ball-bowling.js"));

var _ballTennis = _interopRequireDefault(require("./icons/ball-tennis.js"));

var _ballVolleyball = _interopRequireDefault(require("./icons/ball-volleyball.js"));

var _ban = _interopRequireDefault(require("./icons/ban.js"));

var _bandage = _interopRequireDefault(require("./icons/bandage.js"));

var _barcode = _interopRequireDefault(require("./icons/barcode.js"));

var _basket = _interopRequireDefault(require("./icons/basket.js"));

var _battery = _interopRequireDefault(require("./icons/battery-1.js"));

var _battery2 = _interopRequireDefault(require("./icons/battery-2.js"));

var _battery3 = _interopRequireDefault(require("./icons/battery-3.js"));

var _battery4 = _interopRequireDefault(require("./icons/battery-4.js"));

var _batteryCharging = _interopRequireDefault(require("./icons/battery-charging.js"));

var _batteryOff = _interopRequireDefault(require("./icons/battery-off.js"));

var _battery5 = _interopRequireDefault(require("./icons/battery.js"));

var _bed = _interopRequireDefault(require("./icons/bed.js"));

var _bellOff = _interopRequireDefault(require("./icons/bell-off.js"));

var _bellRinging = _interopRequireDefault(require("./icons/bell-ringing.js"));

var _bell = _interopRequireDefault(require("./icons/bell.js"));

var _bike = _interopRequireDefault(require("./icons/bike.js"));

var _biohazard = _interopRequireDefault(require("./icons/biohazard.js"));

var _bluetoothConnected = _interopRequireDefault(require("./icons/bluetooth-connected.js"));

var _bluetoothOff = _interopRequireDefault(require("./icons/bluetooth-off.js"));

var _bluetooth = _interopRequireDefault(require("./icons/bluetooth.js"));

var _bold = _interopRequireDefault(require("./icons/bold.js"));

var _boltOff = _interopRequireDefault(require("./icons/bolt-off.js"));

var _bolt = _interopRequireDefault(require("./icons/bolt.js"));

var _book = _interopRequireDefault(require("./icons/book.js"));

var _bookmarkOff = _interopRequireDefault(require("./icons/bookmark-off.js"));

var _bookmark = _interopRequireDefault(require("./icons/bookmark.js"));

var _bookmarks = _interopRequireDefault(require("./icons/bookmarks.js"));

var _borderAll = _interopRequireDefault(require("./icons/border-all.js"));

var _borderBottom = _interopRequireDefault(require("./icons/border-bottom.js"));

var _borderHorizontal = _interopRequireDefault(require("./icons/border-horizontal.js"));

var _borderInner = _interopRequireDefault(require("./icons/border-inner.js"));

var _borderLeft = _interopRequireDefault(require("./icons/border-left.js"));

var _borderNone = _interopRequireDefault(require("./icons/border-none.js"));

var _borderOuter = _interopRequireDefault(require("./icons/border-outer.js"));

var _borderRadius = _interopRequireDefault(require("./icons/border-radius.js"));

var _borderRight = _interopRequireDefault(require("./icons/border-right.js"));

var _borderTop = _interopRequireDefault(require("./icons/border-top.js"));

var _borderVertical = _interopRequireDefault(require("./icons/border-vertical.js"));

var _box = _interopRequireDefault(require("./icons/box.js"));

var _braces = _interopRequireDefault(require("./icons/braces.js"));

var _brackets = _interopRequireDefault(require("./icons/brackets.js"));

var _brandAirbnb = _interopRequireDefault(require("./icons/brand-airbnb.js"));

var _brandAndroid = _interopRequireDefault(require("./icons/brand-android.js"));

var _brandAppleArcade = _interopRequireDefault(require("./icons/brand-apple-arcade.js"));

var _brandApple = _interopRequireDefault(require("./icons/brand-apple.js"));

var _brandAppstore = _interopRequireDefault(require("./icons/brand-appstore.js"));

var _brandBehance = _interopRequireDefault(require("./icons/brand-behance.js"));

var _brandChrome = _interopRequireDefault(require("./icons/brand-chrome.js"));

var _brandCodepen = _interopRequireDefault(require("./icons/brand-codepen.js"));

var _brandCodesandbox = _interopRequireDefault(require("./icons/brand-codesandbox.js"));

var _brandCss = _interopRequireDefault(require("./icons/brand-css3.js"));

var _brandDeviantart = _interopRequireDefault(require("./icons/brand-deviantart.js"));

var _brandDiscord = _interopRequireDefault(require("./icons/brand-discord.js"));

var _brandDribbble = _interopRequireDefault(require("./icons/brand-dribbble.js"));

var _brandEdge = _interopRequireDefault(require("./icons/brand-edge.js"));

var _brandFacebook = _interopRequireDefault(require("./icons/brand-facebook.js"));

var _brandFigma = _interopRequireDefault(require("./icons/brand-figma.js"));

var _brandFirefox = _interopRequireDefault(require("./icons/brand-firefox.js"));

var _brandFlickr = _interopRequireDefault(require("./icons/brand-flickr.js"));

var _brandFoursquare = _interopRequireDefault(require("./icons/brand-foursquare.js"));

var _brandFramer = _interopRequireDefault(require("./icons/brand-framer.js"));

var _brandGithub = _interopRequireDefault(require("./icons/brand-github.js"));

var _brandGitlab = _interopRequireDefault(require("./icons/brand-gitlab.js"));

var _brandGoogleDrive = _interopRequireDefault(require("./icons/brand-google-drive.js"));

var _brandGooglePlay = _interopRequireDefault(require("./icons/brand-google-play.js"));

var _brandGoogle = _interopRequireDefault(require("./icons/brand-google.js"));

var _brandHtml = _interopRequireDefault(require("./icons/brand-html5.js"));

var _brandInstagram = _interopRequireDefault(require("./icons/brand-instagram.js"));

var _brandKotlin = _interopRequireDefault(require("./icons/brand-kotlin.js"));

var _brandLinkedin = _interopRequireDefault(require("./icons/brand-linkedin.js"));

var _brandMedium = _interopRequireDefault(require("./icons/brand-medium.js"));

var _brandMessenger = _interopRequireDefault(require("./icons/brand-messenger.js"));

var _brandOpera = _interopRequireDefault(require("./icons/brand-opera.js"));

var _brandPaypal = _interopRequireDefault(require("./icons/brand-paypal.js"));

var _brandPinterest = _interopRequireDefault(require("./icons/brand-pinterest.js"));

var _brandPocket = _interopRequireDefault(require("./icons/brand-pocket.js"));

var _brandPython = _interopRequireDefault(require("./icons/brand-python.js"));

var _brandReddit = _interopRequireDefault(require("./icons/brand-reddit.js"));

var _brandSafari = _interopRequireDefault(require("./icons/brand-safari.js"));

var _brandSketch = _interopRequireDefault(require("./icons/brand-sketch.js"));

var _brandSkype = _interopRequireDefault(require("./icons/brand-skype.js"));

var _brandSlack = _interopRequireDefault(require("./icons/brand-slack.js"));

var _brandSnapchat = _interopRequireDefault(require("./icons/brand-snapchat.js"));

var _brandSoundcloud = _interopRequireDefault(require("./icons/brand-soundcloud.js"));

var _brandSpotify = _interopRequireDefault(require("./icons/brand-spotify.js"));

var _brandSteam = _interopRequireDefault(require("./icons/brand-steam.js"));

var _brandTabler = _interopRequireDefault(require("./icons/brand-tabler.js"));

var _brandTailwind = _interopRequireDefault(require("./icons/brand-tailwind.js"));

var _brandTelegram = _interopRequireDefault(require("./icons/brand-telegram.js"));

var _brandTidal = _interopRequireDefault(require("./icons/brand-tidal.js"));

var _brandTiktok = _interopRequireDefault(require("./icons/brand-tiktok.js"));

var _brandTinder = _interopRequireDefault(require("./icons/brand-tinder.js"));

var _brandTumblr = _interopRequireDefault(require("./icons/brand-tumblr.js"));

var _brandTwitch = _interopRequireDefault(require("./icons/brand-twitch.js"));

var _brandTwitter = _interopRequireDefault(require("./icons/brand-twitter.js"));

var _brandVimeo = _interopRequireDefault(require("./icons/brand-vimeo.js"));

var _brandVk = _interopRequireDefault(require("./icons/brand-vk.js"));

var _brandWhatsapp = _interopRequireDefault(require("./icons/brand-whatsapp.js"));

var _brandWindows = _interopRequireDefault(require("./icons/brand-windows.js"));

var _brandYahoo = _interopRequireDefault(require("./icons/brand-yahoo.js"));

var _brandYoutube = _interopRequireDefault(require("./icons/brand-youtube.js"));

var _briefcase = _interopRequireDefault(require("./icons/briefcase.js"));

var _brightnessDown = _interopRequireDefault(require("./icons/brightness-down.js"));

var _brightnessUp = _interopRequireDefault(require("./icons/brightness-up.js"));

var _brightness = _interopRequireDefault(require("./icons/brightness.js"));

var _browser = _interopRequireDefault(require("./icons/browser.js"));

var _brush = _interopRequireDefault(require("./icons/brush.js"));

var _bucket = _interopRequireDefault(require("./icons/bucket.js"));

var _bug = _interopRequireDefault(require("./icons/bug.js"));

var _buildingArch = _interopRequireDefault(require("./icons/building-arch.js"));

var _buildingBank = _interopRequireDefault(require("./icons/building-bank.js"));

var _buildingBridge = _interopRequireDefault(require("./icons/building-bridge-2.js"));

var _buildingBridge2 = _interopRequireDefault(require("./icons/building-bridge.js"));

var _buildingCarousel = _interopRequireDefault(require("./icons/building-carousel.js"));

var _buildingCastle = _interopRequireDefault(require("./icons/building-castle.js"));

var _buildingChurch = _interopRequireDefault(require("./icons/building-church.js"));

var _buildingCommunity = _interopRequireDefault(require("./icons/building-community.js"));

var _buildingFortress = _interopRequireDefault(require("./icons/building-fortress.js"));

var _buildingHospital = _interopRequireDefault(require("./icons/building-hospital.js"));

var _buildingLighthouse = _interopRequireDefault(require("./icons/building-lighthouse.js"));

var _buildingMonument = _interopRequireDefault(require("./icons/building-monument.js"));

var _buildingPavilon = _interopRequireDefault(require("./icons/building-pavilon.js"));

var _buildingSkyscraper = _interopRequireDefault(require("./icons/building-skyscraper.js"));

var _buildingStore = _interopRequireDefault(require("./icons/building-store.js"));

var _buildingWarehouse = _interopRequireDefault(require("./icons/building-warehouse.js"));

var _building = _interopRequireDefault(require("./icons/building.js"));

var _bulbOff = _interopRequireDefault(require("./icons/bulb-off.js"));

var _bulb = _interopRequireDefault(require("./icons/bulb.js"));

var _buldozer = _interopRequireDefault(require("./icons/buldozer.js"));

var _bus = _interopRequireDefault(require("./icons/bus.js"));

var _calculator = _interopRequireDefault(require("./icons/calculator.js"));

var _calendarEvent = _interopRequireDefault(require("./icons/calendar-event.js"));

var _calendarMinus = _interopRequireDefault(require("./icons/calendar-minus.js"));

var _calendarPlus = _interopRequireDefault(require("./icons/calendar-plus.js"));

var _calendar = _interopRequireDefault(require("./icons/calendar.js"));

var _cameraMinus = _interopRequireDefault(require("./icons/camera-minus.js"));

var _cameraOff = _interopRequireDefault(require("./icons/camera-off.js"));

var _cameraPlus = _interopRequireDefault(require("./icons/camera-plus.js"));

var _camera = _interopRequireDefault(require("./icons/camera.js"));

var _capture = _interopRequireDefault(require("./icons/capture.js"));

var _car = _interopRequireDefault(require("./icons/car.js"));

var _caravan = _interopRequireDefault(require("./icons/caravan.js"));

var _cardboards = _interopRequireDefault(require("./icons/cardboards.js"));

var _caretDown = _interopRequireDefault(require("./icons/caret-down.js"));

var _caretLeft = _interopRequireDefault(require("./icons/caret-left.js"));

var _caretRight = _interopRequireDefault(require("./icons/caret-right.js"));

var _caretUp = _interopRequireDefault(require("./icons/caret-up.js"));

var _cash = _interopRequireDefault(require("./icons/cash.js"));

var _cast = _interopRequireDefault(require("./icons/cast.js"));

var _ce = _interopRequireDefault(require("./icons/ce.js"));

var _certificate = _interopRequireDefault(require("./icons/certificate.js"));

var _chartAreaLine = _interopRequireDefault(require("./icons/chart-area-line.js"));

var _chartArea = _interopRequireDefault(require("./icons/chart-area.js"));

var _chartBar = _interopRequireDefault(require("./icons/chart-bar.js"));

var _chartBubble = _interopRequireDefault(require("./icons/chart-bubble.js"));

var _chartCandle = _interopRequireDefault(require("./icons/chart-candle.js"));

var _chartDonut = _interopRequireDefault(require("./icons/chart-donut.js"));

var _chartLine = _interopRequireDefault(require("./icons/chart-line.js"));

var _chartPie = _interopRequireDefault(require("./icons/chart-pie.js"));

var _chartRadar = _interopRequireDefault(require("./icons/chart-radar.js"));

var _check = _interopRequireDefault(require("./icons/check.js"));

var _checkbox = _interopRequireDefault(require("./icons/checkbox.js"));

var _checks = _interopRequireDefault(require("./icons/checks.js"));

var _chevronDownLeft = _interopRequireDefault(require("./icons/chevron-down-left.js"));

var _chevronDownRight = _interopRequireDefault(require("./icons/chevron-down-right.js"));

var _chevronDown = _interopRequireDefault(require("./icons/chevron-down.js"));

var _chevronLeft = _interopRequireDefault(require("./icons/chevron-left.js"));

var _chevronRight = _interopRequireDefault(require("./icons/chevron-right.js"));

var _chevronUpLeft = _interopRequireDefault(require("./icons/chevron-up-left.js"));

var _chevronUpRight = _interopRequireDefault(require("./icons/chevron-up-right.js"));

var _chevronUp = _interopRequireDefault(require("./icons/chevron-up.js"));

var _chevronsDownLeft = _interopRequireDefault(require("./icons/chevrons-down-left.js"));

var _chevronsDownRight = _interopRequireDefault(require("./icons/chevrons-down-right.js"));

var _chevronsDown = _interopRequireDefault(require("./icons/chevrons-down.js"));

var _chevronsLeft = _interopRequireDefault(require("./icons/chevrons-left.js"));

var _chevronsRight = _interopRequireDefault(require("./icons/chevrons-right.js"));

var _chevronsUpLeft = _interopRequireDefault(require("./icons/chevrons-up-left.js"));

var _chevronsUpRight = _interopRequireDefault(require("./icons/chevrons-up-right.js"));

var _chevronsUp = _interopRequireDefault(require("./icons/chevrons-up.js"));

var _christmasTree = _interopRequireDefault(require("./icons/christmas-tree.js"));

var _circleCheck = _interopRequireDefault(require("./icons/circle-check.js"));

var _circleDashed = _interopRequireDefault(require("./icons/circle-dashed.js"));

var _circleDotted = _interopRequireDefault(require("./icons/circle-dotted.js"));

var _circleMinus = _interopRequireDefault(require("./icons/circle-minus.js"));

var _circlePlus = _interopRequireDefault(require("./icons/circle-plus.js"));

var _circleSquare = _interopRequireDefault(require("./icons/circle-square.js"));

var _circleX = _interopRequireDefault(require("./icons/circle-x.js"));

var _circle = _interopRequireDefault(require("./icons/circle.js"));

var _circles = _interopRequireDefault(require("./icons/circles.js"));

var _clearFormatting = _interopRequireDefault(require("./icons/clear-formatting.js"));

var _click = _interopRequireDefault(require("./icons/click.js"));

var _clipboardCheck = _interopRequireDefault(require("./icons/clipboard-check.js"));

var _clipboardList = _interopRequireDefault(require("./icons/clipboard-list.js"));

var _clipboardX = _interopRequireDefault(require("./icons/clipboard-x.js"));

var _clipboard = _interopRequireDefault(require("./icons/clipboard.js"));

var _clock = _interopRequireDefault(require("./icons/clock.js"));

var _cloudDownload = _interopRequireDefault(require("./icons/cloud-download.js"));

var _cloudFog = _interopRequireDefault(require("./icons/cloud-fog.js"));

var _cloudOff = _interopRequireDefault(require("./icons/cloud-off.js"));

var _cloudRain = _interopRequireDefault(require("./icons/cloud-rain.js"));

var _cloudSnow = _interopRequireDefault(require("./icons/cloud-snow.js"));

var _cloudStorm = _interopRequireDefault(require("./icons/cloud-storm.js"));

var _cloudUpload = _interopRequireDefault(require("./icons/cloud-upload.js"));

var _cloud = _interopRequireDefault(require("./icons/cloud.js"));

var _code = _interopRequireDefault(require("./icons/code.js"));

var _coin = _interopRequireDefault(require("./icons/coin.js"));

var _colorPicker = _interopRequireDefault(require("./icons/color-picker.js"));

var _colorSwatch = _interopRequireDefault(require("./icons/color-swatch.js"));

var _columns = _interopRequireDefault(require("./icons/columns.js"));

var _comet = _interopRequireDefault(require("./icons/comet.js"));

var _command = _interopRequireDefault(require("./icons/command.js"));

var _compass = _interopRequireDefault(require("./icons/compass.js"));

var _contrast = _interopRequireDefault(require("./icons/contrast.js"));

var _copy = _interopRequireDefault(require("./icons/copy.js"));

var _copyleft = _interopRequireDefault(require("./icons/copyleft.js"));

var _copyright = _interopRequireDefault(require("./icons/copyright.js"));

var _cornerDownLeft = _interopRequireDefault(require("./icons/corner-down-left.js"));

var _cornerDownRight = _interopRequireDefault(require("./icons/corner-down-right.js"));

var _cornerLeftDown = _interopRequireDefault(require("./icons/corner-left-down.js"));

var _cornerLeftUp = _interopRequireDefault(require("./icons/corner-left-up.js"));

var _cornerRightDown = _interopRequireDefault(require("./icons/corner-right-down.js"));

var _cornerRightUp = _interopRequireDefault(require("./icons/corner-right-up.js"));

var _cornerUpLeft = _interopRequireDefault(require("./icons/corner-up-left.js"));

var _cornerUpRight = _interopRequireDefault(require("./icons/corner-up-right.js"));

var _creditCardOff = _interopRequireDefault(require("./icons/credit-card-off.js"));

var _creditCard = _interopRequireDefault(require("./icons/credit-card.js"));

var _crop = _interopRequireDefault(require("./icons/crop.js"));

var _crosshair = _interopRequireDefault(require("./icons/crosshair.js"));

var _crown = _interopRequireDefault(require("./icons/crown.js"));

var _curlyLoop = _interopRequireDefault(require("./icons/curly-loop.js"));

var _currencyBitcoin = _interopRequireDefault(require("./icons/currency-bitcoin.js"));

var _currencyDollar = _interopRequireDefault(require("./icons/currency-dollar.js"));

var _currencyEuro = _interopRequireDefault(require("./icons/currency-euro.js"));

var _currencyPound = _interopRequireDefault(require("./icons/currency-pound.js"));

var _currencyRupee = _interopRequireDefault(require("./icons/currency-rupee.js"));

var _currencyYen = _interopRequireDefault(require("./icons/currency-yen.js"));

var _currentLocation = _interopRequireDefault(require("./icons/current-location.js"));

var _cut = _interopRequireDefault(require("./icons/cut.js"));

var _dashboard = _interopRequireDefault(require("./icons/dashboard.js"));

var _database = _interopRequireDefault(require("./icons/database.js"));

var _deviceDesktop = _interopRequireDefault(require("./icons/device-desktop.js"));

var _deviceFloppy = _interopRequireDefault(require("./icons/device-floppy.js"));

var _deviceGamepad = _interopRequireDefault(require("./icons/device-gamepad.js"));

var _deviceLaptop = _interopRequireDefault(require("./icons/device-laptop.js"));

var _deviceMobileRotated = _interopRequireDefault(require("./icons/device-mobile-rotated.js"));

var _deviceMobileVibration = _interopRequireDefault(require("./icons/device-mobile-vibration.js"));

var _deviceMobile = _interopRequireDefault(require("./icons/device-mobile.js"));

var _deviceSpeaker = _interopRequireDefault(require("./icons/device-speaker.js"));

var _deviceTablet = _interopRequireDefault(require("./icons/device-tablet.js"));

var _deviceTv = _interopRequireDefault(require("./icons/device-tv.js"));

var _deviceWatch = _interopRequireDefault(require("./icons/device-watch.js"));

var _devices = _interopRequireDefault(require("./icons/devices-2.js"));

var _devices2 = _interopRequireDefault(require("./icons/devices.js"));

var _diamond = _interopRequireDefault(require("./icons/diamond.js"));

var _dice = _interopRequireDefault(require("./icons/dice.js"));

var _directionHorizontal = _interopRequireDefault(require("./icons/direction-horizontal.js"));

var _direction = _interopRequireDefault(require("./icons/direction.js"));

var _directions = _interopRequireDefault(require("./icons/directions.js"));

var _disabled = _interopRequireDefault(require("./icons/disabled-2.js"));

var _disabled2 = _interopRequireDefault(require("./icons/disabled.js"));

var _disc = _interopRequireDefault(require("./icons/disc.js"));

var _discount = _interopRequireDefault(require("./icons/discount.js"));

var _divide = _interopRequireDefault(require("./icons/divide.js"));

var _dotsCircleHorizontal = _interopRequireDefault(require("./icons/dots-circle-horizontal.js"));

var _dotsDiagonal = _interopRequireDefault(require("./icons/dots-diagonal-2.js"));

var _dotsDiagonal2 = _interopRequireDefault(require("./icons/dots-diagonal.js"));

var _dotsVertical = _interopRequireDefault(require("./icons/dots-vertical.js"));

var _dots = _interopRequireDefault(require("./icons/dots.js"));

var _download = _interopRequireDefault(require("./icons/download.js"));

var _dragDrop = _interopRequireDefault(require("./icons/drag-drop-2.js"));

var _dragDrop2 = _interopRequireDefault(require("./icons/drag-drop.js"));

var _drone = _interopRequireDefault(require("./icons/drone.js"));

var _droplet = _interopRequireDefault(require("./icons/droplet.js"));

var _ear = _interopRequireDefault(require("./icons/ear.js"));

var _edit = _interopRequireDefault(require("./icons/edit.js"));

var _egg = _interopRequireDefault(require("./icons/egg.js"));

var _emphasis = _interopRequireDefault(require("./icons/emphasis.js"));

var _eraser = _interopRequireDefault(require("./icons/eraser.js"));

var _exchange = _interopRequireDefault(require("./icons/exchange.js"));

var _exposure = _interopRequireDefault(require("./icons/exposure.js"));

var _externalLink = _interopRequireDefault(require("./icons/external-link.js"));

var _eyeOff = _interopRequireDefault(require("./icons/eye-off.js"));

var _eye = _interopRequireDefault(require("./icons/eye.js"));

var _faceId = _interopRequireDefault(require("./icons/face-id.js"));

var _fall = _interopRequireDefault(require("./icons/fall.js"));

var _fileCertificate = _interopRequireDefault(require("./icons/file-certificate.js"));

var _fileCheck = _interopRequireDefault(require("./icons/file-check.js"));

var _fileCode = _interopRequireDefault(require("./icons/file-code.js"));

var _fileDiff = _interopRequireDefault(require("./icons/file-diff.js"));

var _fileDislike = _interopRequireDefault(require("./icons/file-dislike.js"));

var _fileDownload = _interopRequireDefault(require("./icons/file-download.js"));

var _fileHorizontal = _interopRequireDefault(require("./icons/file-horizontal.js"));

var _fileInvoice = _interopRequireDefault(require("./icons/file-invoice.js"));

var _fileLike = _interopRequireDefault(require("./icons/file-like.js"));

var _fileMinus = _interopRequireDefault(require("./icons/file-minus.js"));

var _fileMusic = _interopRequireDefault(require("./icons/file-music.js"));

var _fileOff = _interopRequireDefault(require("./icons/file-off.js"));

var _filePhone = _interopRequireDefault(require("./icons/file-phone.js"));

var _filePlus = _interopRequireDefault(require("./icons/file-plus.js"));

var _fileSearch = _interopRequireDefault(require("./icons/file-search.js"));

var _fileShredder = _interopRequireDefault(require("./icons/file-shredder.js"));

var _fileSymlink = _interopRequireDefault(require("./icons/file-symlink.js"));

var _fileText = _interopRequireDefault(require("./icons/file-text.js"));

var _fileUpload = _interopRequireDefault(require("./icons/file-upload.js"));

var _fileX = _interopRequireDefault(require("./icons/file-x.js"));

var _fileZip = _interopRequireDefault(require("./icons/file-zip.js"));

var _file = _interopRequireDefault(require("./icons/file.js"));

var _filterOff = _interopRequireDefault(require("./icons/filter-off.js"));

var _filter = _interopRequireDefault(require("./icons/filter.js"));

var _fingerprint = _interopRequireDefault(require("./icons/fingerprint.js"));

var _firetruck = _interopRequireDefault(require("./icons/firetruck.js"));

var _flag = _interopRequireDefault(require("./icons/flag.js"));

var _flame = _interopRequireDefault(require("./icons/flame.js"));

var _flask = _interopRequireDefault(require("./icons/flask.js"));

var _flipHorizontal = _interopRequireDefault(require("./icons/flip-horizontal.js"));

var _flipVertical = _interopRequireDefault(require("./icons/flip-vertical.js"));

var _floatCenter = _interopRequireDefault(require("./icons/float-center.js"));

var _floatLeft = _interopRequireDefault(require("./icons/float-left.js"));

var _floatNone = _interopRequireDefault(require("./icons/float-none.js"));

var _floatRight = _interopRequireDefault(require("./icons/float-right.js"));

var _focus = _interopRequireDefault(require("./icons/focus-2.js"));

var _focus2 = _interopRequireDefault(require("./icons/focus.js"));

var _foldDown = _interopRequireDefault(require("./icons/fold-down.js"));

var _foldUp = _interopRequireDefault(require("./icons/fold-up.js"));

var _fold = _interopRequireDefault(require("./icons/fold.js"));

var _folderMinus = _interopRequireDefault(require("./icons/folder-minus.js"));

var _folderOff = _interopRequireDefault(require("./icons/folder-off.js"));

var _folderPlus = _interopRequireDefault(require("./icons/folder-plus.js"));

var _folderX = _interopRequireDefault(require("./icons/folder-x.js"));

var _folder = _interopRequireDefault(require("./icons/folder.js"));

var _folders = _interopRequireDefault(require("./icons/folders.js"));

var _forbid = _interopRequireDefault(require("./icons/forbid-2.js"));

var _forbid2 = _interopRequireDefault(require("./icons/forbid.js"));

var _forklift = _interopRequireDefault(require("./icons/forklift.js"));

var _frame = _interopRequireDefault(require("./icons/frame.js"));

var _friends = _interopRequireDefault(require("./icons/friends.js"));

var _gasStation = _interopRequireDefault(require("./icons/gas-station.js"));

var _gauge = _interopRequireDefault(require("./icons/gauge.js"));

var _ghost = _interopRequireDefault(require("./icons/ghost.js"));

var _gift = _interopRequireDefault(require("./icons/gift.js"));

var _gitBranch = _interopRequireDefault(require("./icons/git-branch.js"));

var _gitCommit = _interopRequireDefault(require("./icons/git-commit.js"));

var _gitCompare = _interopRequireDefault(require("./icons/git-compare.js"));

var _gitFork = _interopRequireDefault(require("./icons/git-fork.js"));

var _gitMerge = _interopRequireDefault(require("./icons/git-merge.js"));

var _gitPullRequest = _interopRequireDefault(require("./icons/git-pull-request.js"));

var _glassFull = _interopRequireDefault(require("./icons/glass-full.js"));

var _glass = _interopRequireDefault(require("./icons/glass.js"));

var _globe = _interopRequireDefault(require("./icons/globe.js"));

var _golf = _interopRequireDefault(require("./icons/golf.js"));

var _gps = _interopRequireDefault(require("./icons/gps.js"));

var _gridDots = _interopRequireDefault(require("./icons/grid-dots.js"));

var _grid = _interopRequireDefault(require("./icons/grid.js"));

var _gripHorizontal = _interopRequireDefault(require("./icons/grip-horizontal.js"));

var _gripVertical = _interopRequireDefault(require("./icons/grip-vertical.js"));

var _h = _interopRequireDefault(require("./icons/h-1.js"));

var _h2 = _interopRequireDefault(require("./icons/h-2.js"));

var _h3 = _interopRequireDefault(require("./icons/h-3.js"));

var _h4 = _interopRequireDefault(require("./icons/h-4.js"));

var _h5 = _interopRequireDefault(require("./icons/h-5.js"));

var _h6 = _interopRequireDefault(require("./icons/h-6.js"));

var _handMiddleFinger = _interopRequireDefault(require("./icons/hand-middle-finger.js"));

var _handOff = _interopRequireDefault(require("./icons/hand-off.js"));

var _handStop = _interopRequireDefault(require("./icons/hand-stop.js"));

var _hash = _interopRequireDefault(require("./icons/hash.js"));

var _headphonesOff = _interopRequireDefault(require("./icons/headphones-off.js"));

var _headphones = _interopRequireDefault(require("./icons/headphones.js"));

var _headset = _interopRequireDefault(require("./icons/headset.js"));

var _heartBroken = _interopRequireDefault(require("./icons/heart-broken.js"));

var _heart = _interopRequireDefault(require("./icons/heart.js"));

var _helicopterLanding = _interopRequireDefault(require("./icons/helicopter-landing.js"));

var _helicopter = _interopRequireDefault(require("./icons/helicopter.js"));

var _help = _interopRequireDefault(require("./icons/help.js"));

var _hexagon = _interopRequireDefault(require("./icons/hexagon.js"));

var _history = _interopRequireDefault(require("./icons/history.js"));

var _home = _interopRequireDefault(require("./icons/home-2.js"));

var _home2 = _interopRequireDefault(require("./icons/home.js"));

var _iceCream = _interopRequireDefault(require("./icons/ice-cream.js"));

var _id = _interopRequireDefault(require("./icons/id.js"));

var _inbox = _interopRequireDefault(require("./icons/inbox.js"));

var _indentDecrease = _interopRequireDefault(require("./icons/indent-decrease.js"));

var _indentIncrease = _interopRequireDefault(require("./icons/indent-increase.js"));

var _infinity = _interopRequireDefault(require("./icons/infinity.js"));

var _infoCircle = _interopRequireDefault(require("./icons/info-circle.js"));

var _infoSquare = _interopRequireDefault(require("./icons/info-square.js"));

var _italic = _interopRequireDefault(require("./icons/italic.js"));

var _jumpRope = _interopRequireDefault(require("./icons/jump-rope.js"));

var _karate = _interopRequireDefault(require("./icons/karate.js"));

var _key = _interopRequireDefault(require("./icons/key.js"));

var _keyboardHide = _interopRequireDefault(require("./icons/keyboard-hide.js"));

var _keyboardShow = _interopRequireDefault(require("./icons/keyboard-show.js"));

var _keyboard = _interopRequireDefault(require("./icons/keyboard.js"));

var _language = _interopRequireDefault(require("./icons/language.js"));

var _layersDifference = _interopRequireDefault(require("./icons/layers-difference.js"));

var _layersIntersect = _interopRequireDefault(require("./icons/layers-intersect.js"));

var _layersSubtract = _interopRequireDefault(require("./icons/layers-subtract.js"));

var _layersUnion = _interopRequireDefault(require("./icons/layers-union.js"));

var _layout = _interopRequireDefault(require("./icons/layout-2.js"));

var _layoutAlignBottom = _interopRequireDefault(require("./icons/layout-align-bottom.js"));

var _layoutAlignCenter = _interopRequireDefault(require("./icons/layout-align-center.js"));

var _layoutAlignLeft = _interopRequireDefault(require("./icons/layout-align-left.js"));

var _layoutAlignMiddle = _interopRequireDefault(require("./icons/layout-align-middle.js"));

var _layoutAlignRight = _interopRequireDefault(require("./icons/layout-align-right.js"));

var _layoutAlignTop = _interopRequireDefault(require("./icons/layout-align-top.js"));

var _layoutBottombar = _interopRequireDefault(require("./icons/layout-bottombar.js"));

var _layoutCards = _interopRequireDefault(require("./icons/layout-cards.js"));

var _layoutColumns = _interopRequireDefault(require("./icons/layout-columns.js"));

var _layoutDistributeHorizontal = _interopRequireDefault(require("./icons/layout-distribute-horizontal.js"));

var _layoutDistributeVertical = _interopRequireDefault(require("./icons/layout-distribute-vertical.js"));

var _layoutKanban = _interopRequireDefault(require("./icons/layout-kanban.js"));

var _layoutList = _interopRequireDefault(require("./icons/layout-list.js"));

var _layoutNavbar = _interopRequireDefault(require("./icons/layout-navbar.js"));

var _layoutRows = _interopRequireDefault(require("./icons/layout-rows.js"));

var _layoutSidebarRight = _interopRequireDefault(require("./icons/layout-sidebar-right.js"));

var _layoutSidebar = _interopRequireDefault(require("./icons/layout-sidebar.js"));

var _layout2 = _interopRequireDefault(require("./icons/layout.js"));

var _leaf = _interopRequireDefault(require("./icons/leaf.js"));

var _lego = _interopRequireDefault(require("./icons/lego.js"));

var _letterA = _interopRequireDefault(require("./icons/letter-a.js"));

var _letterB = _interopRequireDefault(require("./icons/letter-b.js"));

var _letterC = _interopRequireDefault(require("./icons/letter-c.js"));

var _letterD = _interopRequireDefault(require("./icons/letter-d.js"));

var _letterE = _interopRequireDefault(require("./icons/letter-e.js"));

var _letterF = _interopRequireDefault(require("./icons/letter-f.js"));

var _letterG = _interopRequireDefault(require("./icons/letter-g.js"));

var _letterH = _interopRequireDefault(require("./icons/letter-h.js"));

var _letterI = _interopRequireDefault(require("./icons/letter-i.js"));

var _letterJ = _interopRequireDefault(require("./icons/letter-j.js"));

var _letterK = _interopRequireDefault(require("./icons/letter-k.js"));

var _letterL = _interopRequireDefault(require("./icons/letter-l.js"));

var _letterM = _interopRequireDefault(require("./icons/letter-m.js"));

var _letterN = _interopRequireDefault(require("./icons/letter-n.js"));

var _letterO = _interopRequireDefault(require("./icons/letter-o.js"));

var _letterP = _interopRequireDefault(require("./icons/letter-p.js"));

var _letterQ = _interopRequireDefault(require("./icons/letter-q.js"));

var _letterR = _interopRequireDefault(require("./icons/letter-r.js"));

var _letterS = _interopRequireDefault(require("./icons/letter-s.js"));

var _letterT = _interopRequireDefault(require("./icons/letter-t.js"));

var _letterU = _interopRequireDefault(require("./icons/letter-u.js"));

var _letterV = _interopRequireDefault(require("./icons/letter-v.js"));

var _letterW = _interopRequireDefault(require("./icons/letter-w.js"));

var _letterX = _interopRequireDefault(require("./icons/letter-x.js"));

var _letterY = _interopRequireDefault(require("./icons/letter-y.js"));

var _letterZ = _interopRequireDefault(require("./icons/letter-z.js"));

var _lettersCase = _interopRequireDefault(require("./icons/letters-case.js"));

var _license = _interopRequireDefault(require("./icons/license.js"));

var _lifebuoy = _interopRequireDefault(require("./icons/lifebuoy.js"));

var _lineHeight = _interopRequireDefault(require("./icons/line-height.js"));

var _line = _interopRequireDefault(require("./icons/line.js"));

var _link = _interopRequireDefault(require("./icons/link.js"));

var _listCheck = _interopRequireDefault(require("./icons/list-check.js"));

var _list = _interopRequireDefault(require("./icons/list.js"));

var _livePhoto = _interopRequireDefault(require("./icons/live-photo.js"));

var _liveView = _interopRequireDefault(require("./icons/live-view.js"));

var _loaderQuarter = _interopRequireDefault(require("./icons/loader-quarter.js"));

var _loader = _interopRequireDefault(require("./icons/loader.js"));

var _location = _interopRequireDefault(require("./icons/location.js"));

var _lockOff = _interopRequireDefault(require("./icons/lock-off.js"));

var _lockOpen = _interopRequireDefault(require("./icons/lock-open.js"));

var _lock = _interopRequireDefault(require("./icons/lock.js"));

var _login = _interopRequireDefault(require("./icons/login.js"));

var _logout = _interopRequireDefault(require("./icons/logout.js"));

var _magnet = _interopRequireDefault(require("./icons/magnet.js"));

var _mailOpened = _interopRequireDefault(require("./icons/mail-opened.js"));

var _mail = _interopRequireDefault(require("./icons/mail.js"));

var _man = _interopRequireDefault(require("./icons/man.js"));

var _manualGearbox = _interopRequireDefault(require("./icons/manual-gearbox.js"));

var _map = _interopRequireDefault(require("./icons/map-2.js"));

var _mapPinOff = _interopRequireDefault(require("./icons/map-pin-off.js"));

var _mapPin = _interopRequireDefault(require("./icons/map-pin.js"));

var _mapPins = _interopRequireDefault(require("./icons/map-pins.js"));

var _map2 = _interopRequireDefault(require("./icons/map.js"));

var _markdown = _interopRequireDefault(require("./icons/markdown.js"));

var _marquee = _interopRequireDefault(require("./icons/marquee.js"));

var _mars = _interopRequireDefault(require("./icons/mars.js"));

var _math = _interopRequireDefault(require("./icons/math.js"));

var _maximize = _interopRequireDefault(require("./icons/maximize.js"));

var _medal = _interopRequireDefault(require("./icons/medal.js"));

var _medicalCross = _interopRequireDefault(require("./icons/medical-cross.js"));

var _menu = _interopRequireDefault(require("./icons/menu-2.js"));

var _menu2 = _interopRequireDefault(require("./icons/menu.js"));

var _message = _interopRequireDefault(require("./icons/message-2.js"));

var _messageCircle = _interopRequireDefault(require("./icons/message-circle-2.js"));

var _messageCircleOff = _interopRequireDefault(require("./icons/message-circle-off.js"));

var _messageCircle2 = _interopRequireDefault(require("./icons/message-circle.js"));

var _messageDots = _interopRequireDefault(require("./icons/message-dots.js"));

var _messageOff = _interopRequireDefault(require("./icons/message-off.js"));

var _messagePlus = _interopRequireDefault(require("./icons/message-plus.js"));

var _messageReport = _interopRequireDefault(require("./icons/message-report.js"));

var _message2 = _interopRequireDefault(require("./icons/message.js"));

var _messagesOff = _interopRequireDefault(require("./icons/messages-off.js"));

var _messages = _interopRequireDefault(require("./icons/messages.js"));

var _microphoneOff = _interopRequireDefault(require("./icons/microphone-off.js"));

var _microphone = _interopRequireDefault(require("./icons/microphone.js"));

var _minimize = _interopRequireDefault(require("./icons/minimize.js"));

var _minus = _interopRequireDefault(require("./icons/minus.js"));

var _mist = _interopRequireDefault(require("./icons/mist.js"));

var _moodBoy = _interopRequireDefault(require("./icons/mood-boy.js"));

var _moodConfuzed = _interopRequireDefault(require("./icons/mood-confuzed.js"));

var _moodCrazyHappy = _interopRequireDefault(require("./icons/mood-crazy-happy.js"));

var _moodCry = _interopRequireDefault(require("./icons/mood-cry.js"));

var _moodHappy = _interopRequireDefault(require("./icons/mood-happy.js"));

var _moodKid = _interopRequireDefault(require("./icons/mood-kid.js"));

var _moodNeutral = _interopRequireDefault(require("./icons/mood-neutral.js"));

var _moodSad = _interopRequireDefault(require("./icons/mood-sad.js"));

var _moodSmile = _interopRequireDefault(require("./icons/mood-smile.js"));

var _moodSuprised = _interopRequireDefault(require("./icons/mood-suprised.js"));

var _moodTongue = _interopRequireDefault(require("./icons/mood-tongue.js"));

var _moon = _interopRequireDefault(require("./icons/moon-2.js"));

var _moonStars = _interopRequireDefault(require("./icons/moon-stars.js"));

var _moon2 = _interopRequireDefault(require("./icons/moon.js"));

var _moped = _interopRequireDefault(require("./icons/moped.js"));

var _mouse = _interopRequireDefault(require("./icons/mouse.js"));

var _movie = _interopRequireDefault(require("./icons/movie.js"));

var _mug = _interopRequireDefault(require("./icons/mug.js"));

var _music = _interopRequireDefault(require("./icons/music.js"));

var _newSection = _interopRequireDefault(require("./icons/new-section.js"));

var _news = _interopRequireDefault(require("./icons/news.js"));

var _note = _interopRequireDefault(require("./icons/note.js"));

var _notebook = _interopRequireDefault(require("./icons/notebook.js"));

var _notes = _interopRequireDefault(require("./icons/notes.js"));

var _notification = _interopRequireDefault(require("./icons/notification.js"));

var _octagon = _interopRequireDefault(require("./icons/octagon.js"));

var _omega = _interopRequireDefault(require("./icons/omega.js"));

var _outlet = _interopRequireDefault(require("./icons/outlet.js"));

var _package = _interopRequireDefault(require("./icons/package.js"));

var _pageBreak = _interopRequireDefault(require("./icons/page-break.js"));

var _paint = _interopRequireDefault(require("./icons/paint.js"));

var _palette = _interopRequireDefault(require("./icons/palette.js"));

var _panoramaHorizontal = _interopRequireDefault(require("./icons/panorama-horizontal.js"));

var _panoramaVertical = _interopRequireDefault(require("./icons/panorama-vertical.js"));

var _paperclip = _interopRequireDefault(require("./icons/paperclip.js"));

var _parachute = _interopRequireDefault(require("./icons/parachute.js"));

var _parentheses = _interopRequireDefault(require("./icons/parentheses.js"));

var _parking = _interopRequireDefault(require("./icons/parking.js"));

var _peace = _interopRequireDefault(require("./icons/peace.js"));

var _pencil = _interopRequireDefault(require("./icons/pencil.js"));

var _pennant = _interopRequireDefault(require("./icons/pennant.js"));

var _percentage = _interopRequireDefault(require("./icons/percentage.js"));

var _phoneCall = _interopRequireDefault(require("./icons/phone-call.js"));

var _phoneCalling = _interopRequireDefault(require("./icons/phone-calling.js"));

var _phoneCheck = _interopRequireDefault(require("./icons/phone-check.js"));

var _phoneIncoming = _interopRequireDefault(require("./icons/phone-incoming.js"));

var _phoneOff = _interopRequireDefault(require("./icons/phone-off.js"));

var _phoneOutgoing = _interopRequireDefault(require("./icons/phone-outgoing.js"));

var _phonePause = _interopRequireDefault(require("./icons/phone-pause.js"));

var _phonePlus = _interopRequireDefault(require("./icons/phone-plus.js"));

var _phoneX = _interopRequireDefault(require("./icons/phone-x.js"));

var _phone = _interopRequireDefault(require("./icons/phone.js"));

var _photoOff = _interopRequireDefault(require("./icons/photo-off.js"));

var _photo = _interopRequireDefault(require("./icons/photo.js"));

var _pictureInPictureOff = _interopRequireDefault(require("./icons/picture-in-picture-off.js"));

var _pictureInPictureOn = _interopRequireDefault(require("./icons/picture-in-picture-on.js"));

var _pictureInPicture = _interopRequireDefault(require("./icons/picture-in-picture.js"));

var _pill = _interopRequireDefault(require("./icons/pill.js"));

var _pin = _interopRequireDefault(require("./icons/pin.js"));

var _pinnedOff = _interopRequireDefault(require("./icons/pinned-off.js"));

var _pinned = _interopRequireDefault(require("./icons/pinned.js"));

var _planeArrival = _interopRequireDefault(require("./icons/plane-arrival.js"));

var _planeDeparture = _interopRequireDefault(require("./icons/plane-departure.js"));

var _plane = _interopRequireDefault(require("./icons/plane.js"));

var _planet = _interopRequireDefault(require("./icons/planet.js"));

var _plant = _interopRequireDefault(require("./icons/plant-2.js"));

var _plant2 = _interopRequireDefault(require("./icons/plant.js"));

var _playerPause = _interopRequireDefault(require("./icons/player-pause.js"));

var _playerPlay = _interopRequireDefault(require("./icons/player-play.js"));

var _playerRecord = _interopRequireDefault(require("./icons/player-record.js"));

var _playerSkipBack = _interopRequireDefault(require("./icons/player-skip-back.js"));

var _playerSkipForward = _interopRequireDefault(require("./icons/player-skip-forward.js"));

var _playerStop = _interopRequireDefault(require("./icons/player-stop.js"));

var _playerTrackNext = _interopRequireDefault(require("./icons/player-track-next.js"));

var _playerTrackPrev = _interopRequireDefault(require("./icons/player-track-prev.js"));

var _plug = _interopRequireDefault(require("./icons/plug.js"));

var _plus = _interopRequireDefault(require("./icons/plus.js"));

var _point = _interopRequireDefault(require("./icons/point.js"));

var _pool = _interopRequireDefault(require("./icons/pool.js"));

var _power = _interopRequireDefault(require("./icons/power.js"));

var _pray = _interopRequireDefault(require("./icons/pray.js"));

var _presentation = _interopRequireDefault(require("./icons/presentation.js"));

var _printer = _interopRequireDefault(require("./icons/printer.js"));

var _prompt = _interopRequireDefault(require("./icons/prompt.js"));

var _puzzle = _interopRequireDefault(require("./icons/puzzle.js"));

var _qrcode = _interopRequireDefault(require("./icons/qrcode.js"));

var _questionMark = _interopRequireDefault(require("./icons/question-mark.js"));

var _radioactive = _interopRequireDefault(require("./icons/radioactive.js"));

var _recordMail = _interopRequireDefault(require("./icons/record-mail.js"));

var _rectangleVertical = _interopRequireDefault(require("./icons/rectangle-vertical.js"));

var _rectangle = _interopRequireDefault(require("./icons/rectangle.js"));

var _recycle = _interopRequireDefault(require("./icons/recycle.js"));

var _refreshAlert = _interopRequireDefault(require("./icons/refresh-alert.js"));

var _refresh = _interopRequireDefault(require("./icons/refresh.js"));

var _registered = _interopRequireDefault(require("./icons/registered.js"));

var _relationManyToMany = _interopRequireDefault(require("./icons/relation-many-to-many.js"));

var _relationOneToMany = _interopRequireDefault(require("./icons/relation-one-to-many.js"));

var _relationOneToOne = _interopRequireDefault(require("./icons/relation-one-to-one.js"));

var _repeatOnce = _interopRequireDefault(require("./icons/repeat-once.js"));

var _repeat = _interopRequireDefault(require("./icons/repeat.js"));

var _replace = _interopRequireDefault(require("./icons/replace.js"));

var _ripple = _interopRequireDefault(require("./icons/ripple.js"));

var _roadSign = _interopRequireDefault(require("./icons/road-sign.js"));

var _rocket = _interopRequireDefault(require("./icons/rocket.js"));

var _rotate = _interopRequireDefault(require("./icons/rotate-2.js"));

var _rotateClockwise = _interopRequireDefault(require("./icons/rotate-clockwise-2.js"));

var _rotateClockwise2 = _interopRequireDefault(require("./icons/rotate-clockwise.js"));

var _rotateRectangle = _interopRequireDefault(require("./icons/rotate-rectangle.js"));

var _rotate2 = _interopRequireDefault(require("./icons/rotate.js"));

var _route = _interopRequireDefault(require("./icons/route.js"));

var _router = _interopRequireDefault(require("./icons/router.js"));

var _rss = _interopRequireDefault(require("./icons/rss.js"));

var _ruler = _interopRequireDefault(require("./icons/ruler.js"));

var _run = _interopRequireDefault(require("./icons/run.js"));

var _sailboat = _interopRequireDefault(require("./icons/sailboat.js"));

var _scale = _interopRequireDefault(require("./icons/scale.js"));

var _scan = _interopRequireDefault(require("./icons/scan.js"));

var _school = _interopRequireDefault(require("./icons/school.js"));

var _scissors = _interopRequireDefault(require("./icons/scissors.js"));

var _scooterElectric = _interopRequireDefault(require("./icons/scooter-electric.js"));

var _scooter = _interopRequireDefault(require("./icons/scooter.js"));

var _screenShareOff = _interopRequireDefault(require("./icons/screen-share-off.js"));

var _screenShare = _interopRequireDefault(require("./icons/screen-share.js"));

var _search = _interopRequireDefault(require("./icons/search.js"));

var _seeding = _interopRequireDefault(require("./icons/seeding.js"));

var _select = _interopRequireDefault(require("./icons/select.js"));

var _selector = _interopRequireDefault(require("./icons/selector.js"));

var _send = _interopRequireDefault(require("./icons/send.js"));

var _separatorHorizontal = _interopRequireDefault(require("./icons/separator-horizontal.js"));

var _separatorVertical = _interopRequireDefault(require("./icons/separator-vertical.js"));

var _separator = _interopRequireDefault(require("./icons/separator.js"));

var _server = _interopRequireDefault(require("./icons/server.js"));

var _servicemark = _interopRequireDefault(require("./icons/servicemark.js"));

var _settings = _interopRequireDefault(require("./icons/settings.js"));

var _shape = _interopRequireDefault(require("./icons/shape.js"));

var _share = _interopRequireDefault(require("./icons/share.js"));

var _shieldCheck = _interopRequireDefault(require("./icons/shield-check.js"));

var _shieldLock = _interopRequireDefault(require("./icons/shield-lock.js"));

var _shieldOff = _interopRequireDefault(require("./icons/shield-off.js"));

var _shieldX = _interopRequireDefault(require("./icons/shield-x.js"));

var _shield = _interopRequireDefault(require("./icons/shield.js"));

var _ship = _interopRequireDefault(require("./icons/ship.js"));

var _shirt = _interopRequireDefault(require("./icons/shirt.js"));

var _shoppingCart = _interopRequireDefault(require("./icons/shopping-cart.js"));

var _sitemap = _interopRequireDefault(require("./icons/sitemap.js"));

var _skateboard = _interopRequireDefault(require("./icons/skateboard.js"));

var _slice = _interopRequireDefault(require("./icons/slice.js"));

var _slideshow = _interopRequireDefault(require("./icons/slideshow.js"));

var _smartHome = _interopRequireDefault(require("./icons/smart-home.js"));

var _smokingNo = _interopRequireDefault(require("./icons/smoking-no.js"));

var _smoking = _interopRequireDefault(require("./icons/smoking.js"));

var _snowflake = _interopRequireDefault(require("./icons/snowflake.js"));

var _soccerField = _interopRequireDefault(require("./icons/soccer-field.js"));

var _social = _interopRequireDefault(require("./icons/social.js"));

var _sortAscending = _interopRequireDefault(require("./icons/sort-ascending.js"));

var _sortDescending = _interopRequireDefault(require("./icons/sort-descending.js"));

var _space = _interopRequireDefault(require("./icons/space.js"));

var _speakerphone = _interopRequireDefault(require("./icons/speakerphone.js"));

var _speedboat = _interopRequireDefault(require("./icons/speedboat.js"));

var _squareCheck = _interopRequireDefault(require("./icons/square-check.js"));

var _squareDot = _interopRequireDefault(require("./icons/square-dot.js"));

var _squareForbid = _interopRequireDefault(require("./icons/square-forbid-2.js"));

var _squareForbid2 = _interopRequireDefault(require("./icons/square-forbid.js"));

var _squareMinus = _interopRequireDefault(require("./icons/square-minus.js"));

var _squarePlus = _interopRequireDefault(require("./icons/square-plus.js"));

var _squareRotated = _interopRequireDefault(require("./icons/square-rotated.js"));

var _squareX = _interopRequireDefault(require("./icons/square-x.js"));

var _square = _interopRequireDefault(require("./icons/square.js"));

var _stack = _interopRequireDefault(require("./icons/stack.js"));

var _stairsDown = _interopRequireDefault(require("./icons/stairs-down.js"));

var _stairsUp = _interopRequireDefault(require("./icons/stairs-up.js"));

var _stairs = _interopRequireDefault(require("./icons/stairs.js"));

var _starHalf = _interopRequireDefault(require("./icons/star-half.js"));

var _starOff = _interopRequireDefault(require("./icons/star-off.js"));

var _star = _interopRequireDefault(require("./icons/star.js"));

var _stars = _interopRequireDefault(require("./icons/stars.js"));

var _steeringWheel = _interopRequireDefault(require("./icons/steering-wheel.js"));

var _stepInto = _interopRequireDefault(require("./icons/step-into.js"));

var _stepOut = _interopRequireDefault(require("./icons/step-out.js"));

var _sthetoscope = _interopRequireDefault(require("./icons/sthetoscope.js"));

var _sticker = _interopRequireDefault(require("./icons/sticker.js"));

var _strikethrough = _interopRequireDefault(require("./icons/strikethrough.js"));

var _submarine = _interopRequireDefault(require("./icons/submarine.js"));

var _subscript = _interopRequireDefault(require("./icons/subscript.js"));

var _subtask = _interopRequireDefault(require("./icons/subtask.js"));

var _sum = _interopRequireDefault(require("./icons/sum.js"));

var _sunOff = _interopRequireDefault(require("./icons/sun-off.js"));

var _sun = _interopRequireDefault(require("./icons/sun.js"));

var _sunset = _interopRequireDefault(require("./icons/sunset.js"));

var _sunshine = _interopRequireDefault(require("./icons/sunshine.js"));

var _superscript = _interopRequireDefault(require("./icons/superscript.js"));

var _swimming = _interopRequireDefault(require("./icons/swimming.js"));

var _switchHorizontal = _interopRequireDefault(require("./icons/switch-horizontal.js"));

var _switchVertical = _interopRequireDefault(require("./icons/switch-vertical.js"));

var _switch = _interopRequireDefault(require("./icons/switch.js"));

var _table = _interopRequireDefault(require("./icons/table.js"));

var _tag = _interopRequireDefault(require("./icons/tag.js"));

var _tallymark = _interopRequireDefault(require("./icons/tallymark-1.js"));

var _tallymark2 = _interopRequireDefault(require("./icons/tallymark-2.js"));

var _tallymark3 = _interopRequireDefault(require("./icons/tallymark-3.js"));

var _tallymark4 = _interopRequireDefault(require("./icons/tallymark-4.js"));

var _tallymarks = _interopRequireDefault(require("./icons/tallymarks.js"));

var _tank = _interopRequireDefault(require("./icons/tank.js"));

var _target = _interopRequireDefault(require("./icons/target.js"));

var _tax = _interopRequireDefault(require("./icons/tax.js"));

var _temperatureCelsius = _interopRequireDefault(require("./icons/temperature-celsius.js"));

var _temperatureFahrenheit = _interopRequireDefault(require("./icons/temperature-fahrenheit.js"));

var _temperatureMinus = _interopRequireDefault(require("./icons/temperature-minus.js"));

var _temperaturePlus = _interopRequireDefault(require("./icons/temperature-plus.js"));

var _temperature = _interopRequireDefault(require("./icons/temperature.js"));

var _template = _interopRequireDefault(require("./icons/template.js"));

var _terminal = _interopRequireDefault(require("./icons/terminal-2.js"));

var _terminal2 = _interopRequireDefault(require("./icons/terminal.js"));

var _testPipe = _interopRequireDefault(require("./icons/test-pipe.js"));

var _textWrapDisabled = _interopRequireDefault(require("./icons/text-wrap-disabled.js"));

var _textWrap = _interopRequireDefault(require("./icons/text-wrap.js"));

var _thumbDown = _interopRequireDefault(require("./icons/thumb-down.js"));

var _thumbUp = _interopRequireDefault(require("./icons/thumb-up.js"));

var _ticket = _interopRequireDefault(require("./icons/ticket.js"));

var _tir = _interopRequireDefault(require("./icons/tir.js"));

var _toggleLeft = _interopRequireDefault(require("./icons/toggle-left.js"));

var _toggleRight = _interopRequireDefault(require("./icons/toggle-right.js"));

var _tool = _interopRequireDefault(require("./icons/tool.js"));

var _toolsKitchen = _interopRequireDefault(require("./icons/tools-kitchen.js"));

var _tools = _interopRequireDefault(require("./icons/tools.js"));

var _tornado = _interopRequireDefault(require("./icons/tornado.js"));

var _tournament = _interopRequireDefault(require("./icons/tournament.js"));

var _tractor = _interopRequireDefault(require("./icons/tractor.js"));

var _trademark = _interopRequireDefault(require("./icons/trademark.js"));

var _trafficCone = _interopRequireDefault(require("./icons/traffic-cone.js"));

var _trafficLights = _interopRequireDefault(require("./icons/traffic-lights.js"));

var _train = _interopRequireDefault(require("./icons/train.js"));

var _trashOff = _interopRequireDefault(require("./icons/trash-off.js"));

var _trash = _interopRequireDefault(require("./icons/trash.js"));

var _trees = _interopRequireDefault(require("./icons/trees.js"));

var _trendingDown = _interopRequireDefault(require("./icons/trending-down.js"));

var _trendingUp = _interopRequireDefault(require("./icons/trending-up.js"));

var _triangleSquareCircle = _interopRequireDefault(require("./icons/triangle-square-circle.js"));

var _triangle = _interopRequireDefault(require("./icons/triangle.js"));

var _trident = _interopRequireDefault(require("./icons/trident.js"));

var _trophy = _interopRequireDefault(require("./icons/trophy.js"));

var _truckDelivery = _interopRequireDefault(require("./icons/truck-delivery.js"));

var _truckReturn = _interopRequireDefault(require("./icons/truck-return.js"));

var _truck = _interopRequireDefault(require("./icons/truck.js"));

var _typography = _interopRequireDefault(require("./icons/typography.js"));

var _umbrella = _interopRequireDefault(require("./icons/umbrella.js"));

var _underline = _interopRequireDefault(require("./icons/underline.js"));

var _unlink = _interopRequireDefault(require("./icons/unlink.js"));

var _upload = _interopRequireDefault(require("./icons/upload.js"));

var _urgent = _interopRequireDefault(require("./icons/urgent.js"));

var _userCheck = _interopRequireDefault(require("./icons/user-check.js"));

var _userExclamation = _interopRequireDefault(require("./icons/user-exclamation.js"));

var _userMinus = _interopRequireDefault(require("./icons/user-minus.js"));

var _userOff = _interopRequireDefault(require("./icons/user-off.js"));

var _userPlus = _interopRequireDefault(require("./icons/user-plus.js"));

var _userX = _interopRequireDefault(require("./icons/user-x.js"));

var _user = _interopRequireDefault(require("./icons/user.js"));

var _users = _interopRequireDefault(require("./icons/users.js"));

var _vectorBeizer = _interopRequireDefault(require("./icons/vector-beizer-2.js"));

var _vectorBeizer2 = _interopRequireDefault(require("./icons/vector-beizer.js"));

var _vectorTriangle = _interopRequireDefault(require("./icons/vector-triangle.js"));

var _vector = _interopRequireDefault(require("./icons/vector.js"));

var _venus = _interopRequireDefault(require("./icons/venus.js"));

var _versions = _interopRequireDefault(require("./icons/versions.js"));

var _videoMinus = _interopRequireDefault(require("./icons/video-minus.js"));

var _videoOff = _interopRequireDefault(require("./icons/video-off.js"));

var _videoPlus = _interopRequireDefault(require("./icons/video-plus.js"));

var _video = _interopRequireDefault(require("./icons/video.js"));

var _view = _interopRequireDefault(require("./icons/view-360.js"));

var _viewfinder = _interopRequireDefault(require("./icons/viewfinder.js"));

var _viewportNarrow = _interopRequireDefault(require("./icons/viewport-narrow.js"));

var _viewportWide = _interopRequireDefault(require("./icons/viewport-wide.js"));

var _virusOff = _interopRequireDefault(require("./icons/virus-off.js"));

var _virusSearch = _interopRequireDefault(require("./icons/virus-search.js"));

var _virus = _interopRequireDefault(require("./icons/virus.js"));

var _volume = _interopRequireDefault(require("./icons/volume-2.js"));

var _volume2 = _interopRequireDefault(require("./icons/volume-3.js"));

var _volume3 = _interopRequireDefault(require("./icons/volume.js"));

var _walk = _interopRequireDefault(require("./icons/walk.js"));

var _wallet = _interopRequireDefault(require("./icons/wallet.js"));

var _wand = _interopRequireDefault(require("./icons/wand.js"));

var _waveSawTool = _interopRequireDefault(require("./icons/wave-saw-tool.js"));

var _waveSine = _interopRequireDefault(require("./icons/wave-sine.js"));

var _waveSquare = _interopRequireDefault(require("./icons/wave-square.js"));

var _wifi = _interopRequireDefault(require("./icons/wifi-0.js"));

var _wifi2 = _interopRequireDefault(require("./icons/wifi-1.js"));

var _wifi3 = _interopRequireDefault(require("./icons/wifi-2.js"));

var _wifiOff = _interopRequireDefault(require("./icons/wifi-off.js"));

var _wifi4 = _interopRequireDefault(require("./icons/wifi.js"));

var _wind = _interopRequireDefault(require("./icons/wind.js"));

var _windmill = _interopRequireDefault(require("./icons/windmill.js"));

var _wiperWash = _interopRequireDefault(require("./icons/wiper-wash.js"));

var _wiper = _interopRequireDefault(require("./icons/wiper.js"));

var _woman = _interopRequireDefault(require("./icons/woman.js"));

var _worldLatitude = _interopRequireDefault(require("./icons/world-latitude.js"));

var _worldLongitude = _interopRequireDefault(require("./icons/world-longitude.js"));

var _world = _interopRequireDefault(require("./icons/world.js"));

var _wreckingBall = _interopRequireDefault(require("./icons/wrecking-ball.js"));

var _x = _interopRequireDefault(require("./icons/x.js"));

var _yinYang = _interopRequireDefault(require("./icons/yin-yang.js"));

var _zodiacAquarius = _interopRequireDefault(require("./icons/zodiac-aquarius.js"));

var _zodiacAries = _interopRequireDefault(require("./icons/zodiac-aries.js"));

var _zodiacCancer = _interopRequireDefault(require("./icons/zodiac-cancer.js"));

var _zodiacCapricorn = _interopRequireDefault(require("./icons/zodiac-capricorn.js"));

var _zodiacGemini = _interopRequireDefault(require("./icons/zodiac-gemini.js"));

var _zodiacLeo = _interopRequireDefault(require("./icons/zodiac-leo.js"));

var _zodiacLibra = _interopRequireDefault(require("./icons/zodiac-libra.js"));

var _zodiacPisces = _interopRequireDefault(require("./icons/zodiac-pisces.js"));

var _zodiacSagittarius = _interopRequireDefault(require("./icons/zodiac-sagittarius.js"));

var _zodiacScorpio = _interopRequireDefault(require("./icons/zodiac-scorpio.js"));

var _zodiacTaurus = _interopRequireDefault(require("./icons/zodiac-taurus.js"));

var _zodiacVirgo = _interopRequireDefault(require("./icons/zodiac-virgo.js"));

var _zoomCancel = _interopRequireDefault(require("./icons/zoom-cancel.js"));

var _zoomIn = _interopRequireDefault(require("./icons/zoom-in.js"));

var _zoomOut = _interopRequireDefault(require("./icons/zoom-out.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}